var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
  "CIUDAD AUTONOMA DE BUENOS AIRES": {
    "CIUDAD AUTONOMA DE BUENOS AIRES": {
      "1000": true,
      "1001": true,
      "1002": true,
      "1003": true,
      "1004": true,
      "1005": true,
      "1006": true,
      "1007": true,
      "1008": true,
      "1009": true,
      "1010": true,
      "1011": true,
      "1012": true,
      "1013": true,
      "1014": true,
      "1015": true,
      "1016": true,
      "1017": true,
      "1018": true,
      "1019": true,
      "1020": true,
      "1021": true,
      "1022": true,
      "1023": true,
      "1024": true,
      "1025": true,
      "1026": true,
      "1027": true,
      "1028": true,
      "1029": true,
      "1030": true,
      "1031": true,
      "1032": true,
      "1033": true,
      "1034": true,
      "1035": true,
      "1036": true,
      "1037": true,
      "1038": true,
      "1039": true,
      "1040": true,
      "1041": true,
      "1042": true,
      "1043": true,
      "1044": true,
      "1045": true,
      "1046": true,
      "1047": true,
      "1048": true,
      "1049": true,
      "1050": true,
      "1051": true,
      "1052": true,
      "1053": true,
      "1054": true,
      "1055": true,
      "1056": true,
      "1057": true,
      "1058": true,
      "1059": true,
      "1060": true,
      "1061": true,
      "1062": true,
      "1063": true,
      "1064": true,
      "1065": true,
      "1066": true,
      "1067": true,
      "1068": true,
      "1069": true,
      "1070": true,
      "1071": true,
      "1072": true,
      "1073": true,
      "1074": true,
      "1075": true,
      "1076": true,
      "1077": true,
      "1078": true,
      "1079": true,
      "1080": true,
      "1081": true,
      "1082": true,
      "1083": true,
      "1084": true,
      "1085": true,
      "1086": true,
      "1087": true,
      "1088": true,
      "1089": true,
      "1090": true,
      "1091": true,
      "1092": true,
      "1093": true,
      "1094": true,
      "1095": true,
      "1096": true,
      "1097": true,
      "1098": true,
      "1099": true,
      "1100": true,
      "1101": true,
      "1102": true,
      "1103": true,
      "1104": true,
      "1105": true,
      "1106": true,
      "1107": true,
      "1108": true,
      "1109": true,
      "1110": true,
      "1111": true,
      "1112": true,
      "1113": true,
      "1114": true,
      "1115": true,
      "1116": true,
      "1117": true,
      "1118": true,
      "1119": true,
      "1120": true,
      "1121": true,
      "1122": true,
      "1123": true,
      "1124": true,
      "1125": true,
      "1126": true,
      "1127": true,
      "1128": true,
      "1129": true,
      "1130": true,
      "1131": true,
      "1132": true,
      "1133": true,
      "1134": true,
      "1135": true,
      "1136": true,
      "1137": true,
      "1138": true,
      "1139": true,
      "1140": true,
      "1141": true,
      "1142": true,
      "1143": true,
      "1144": true,
      "1145": true,
      "1146": true,
      "1147": true,
      "1148": true,
      "1149": true,
      "1150": true,
      "1151": true,
      "1152": true,
      "1153": true,
      "1154": true,
      "1155": true,
      "1156": true,
      "1157": true,
      "1158": true,
      "1159": true,
      "1160": true,
      "1161": true,
      "1162": true,
      "1163": true,
      "1164": true,
      "1165": true,
      "1166": true,
      "1167": true,
      "1168": true,
      "1169": true,
      "1170": true,
      "1171": true,
      "1172": true,
      "1173": true,
      "1174": true,
      "1175": true,
      "1176": true,
      "1177": true,
      "1178": true,
      "1179": true,
      "1180": true,
      "1181": true,
      "1182": true,
      "1183": true,
      "1184": true,
      "1185": true,
      "1186": true,
      "1187": true,
      "1188": true,
      "1189": true,
      "1190": true,
      "1191": true,
      "1192": true,
      "1193": true,
      "1194": true,
      "1195": true,
      "1196": true,
      "1197": true,
      "1198": true,
      "1199": true,
      "1200": true,
      "1201": true,
      "1202": true,
      "1203": true,
      "1204": true,
      "1205": true,
      "1206": true,
      "1207": true,
      "1208": true,
      "1209": true,
      "1210": true,
      "1211": true,
      "1212": true,
      "1213": true,
      "1214": true,
      "1215": true,
      "1216": true,
      "1217": true,
      "1218": true,
      "1219": true,
      "1220": true,
      "1221": true,
      "1222": true,
      "1223": true,
      "1224": true,
      "1225": true,
      "1226": true,
      "1227": true,
      "1228": true,
      "1229": true,
      "1230": true,
      "1231": true,
      "1232": true,
      "1233": true,
      "1234": true,
      "1235": true,
      "1236": true,
      "1237": true,
      "1238": true,
      "1239": true,
      "1240": true,
      "1241": true,
      "1242": true,
      "1243": true,
      "1244": true,
      "1245": true,
      "1246": true,
      "1247": true,
      "1248": true,
      "1249": true,
      "1250": true,
      "1251": true,
      "1252": true,
      "1253": true,
      "1254": true,
      "1255": true,
      "1256": true,
      "1257": true,
      "1258": true,
      "1259": true,
      "1260": true,
      "1261": true,
      "1262": true,
      "1263": true,
      "1264": true,
      "1265": true,
      "1266": true,
      "1267": true,
      "1268": true,
      "1269": true,
      "1270": true,
      "1271": true,
      "1272": true,
      "1273": true,
      "1274": true,
      "1275": true,
      "1276": true,
      "1277": true,
      "1278": true,
      "1279": true,
      "1280": true,
      "1281": true,
      "1282": true,
      "1283": true,
      "1284": true,
      "1285": true,
      "1286": true,
      "1287": true,
      "1288": true,
      "1289": true,
      "1290": true,
      "1291": true,
      "1292": true,
      "1293": true,
      "1294": true,
      "1295": true,
      "1296": true,
      "1297": true,
      "1298": true,
      "1299": true,
      "1300": true,
      "1301": true,
      "1302": true,
      "1303": true,
      "1304": true,
      "1305": true,
      "1306": true,
      "1307": true,
      "1308": true,
      "1309": true,
      "1310": true,
      "1311": true,
      "1312": true,
      "1313": true,
      "1314": true,
      "1315": true,
      "1316": true,
      "1317": true,
      "1318": true,
      "1319": true,
      "1320": true,
      "1321": true,
      "1322": true,
      "1323": true,
      "1324": true,
      "1325": true,
      "1326": true,
      "1327": true,
      "1328": true,
      "1329": true,
      "1330": true,
      "1331": true,
      "1332": true,
      "1333": true,
      "1334": true,
      "1335": true,
      "1336": true,
      "1337": true,
      "1338": true,
      "1339": true,
      "1340": true,
      "1341": true,
      "1342": true,
      "1343": true,
      "1344": true,
      "1345": true,
      "1346": true,
      "1347": true,
      "1348": true,
      "1349": true,
      "1350": true,
      "1351": true,
      "1352": true,
      "1353": true,
      "1354": true,
      "1355": true,
      "1356": true,
      "1357": true,
      "1358": true,
      "1359": true,
      "1360": true,
      "1361": true,
      "1362": true,
      "1363": true,
      "1364": true,
      "1365": true,
      "1366": true,
      "1367": true,
      "1368": true,
      "1369": true,
      "1370": true,
      "1371": true,
      "1372": true,
      "1373": true,
      "1374": true,
      "1375": true,
      "1376": true,
      "1377": true,
      "1378": true,
      "1379": true,
      "1380": true,
      "1381": true,
      "1382": true,
      "1383": true,
      "1384": true,
      "1385": true,
      "1386": true,
      "1387": true,
      "1388": true,
      "1389": true,
      "1390": true,
      "1391": true,
      "1392": true,
      "1393": true,
      "1394": true,
      "1395": true,
      "1396": true,
      "1397": true,
      "1398": true,
      "1399": true,
      "1400": true,
      "1401": true,
      "1402": true,
      "1403": true,
      "1404": true,
      "1405": true,
      "1406": true,
      "1407": true,
      "1408": true,
      "1409": true,
      "1410": true,
      "1411": true,
      "1412": true,
      "1413": true,
      "1414": true,
      "1415": true,
      "1416": true,
      "1417": true,
      "1418": true,
      "1419": true,
      "1420": true,
      "1421": true,
      "1422": true,
      "1423": true,
      "1424": true,
      "1425": true,
      "1426": true,
      "1427": true,
      "1428": true,
      "1429": true,
      "1430": true,
      "1431": true,
      "1432": true,
      "1433": true,
      "1434": true,
      "1435": true,
      "1436": true,
      "1437": true,
      "1438": true,
      "1439": true,
      "1440": true,
      "1441": true,
      "1442": true,
      "1443": true,
      "1444": true,
      "1445": true,
      "1446": true,
      "1447": true,
      "1448": true,
      "1449": true,
      "1450": true,
      "1451": true,
      "1452": true,
      "1453": true,
      "1454": true,
      "1455": true,
      "1456": true,
      "1458": true,
      "1459": true,
      "1460": true,
      "1461": true,
      "1462": true,
      "1463": true,
      "1464": true,
      "1465": true,
      "1472": true,
      "1479": true,
      "1480": true,
      "1487": true,
      "1507": true,
      "1524": true,
      "1527": true,
      "1599": true,
      "1732": true,
      "1782": true
    }
  },
  "BUENOS AIRES": {
    "VILLA PORVENIR": {
      "1870": true
    },
    "VILLA NUÃEZ": {
      "1874": true
    },
    "SARANDI": {
      "1872": true
    },
    "WILDE ESTE": {
      "1875": true
    },
    "LOMAS DEL MIRADOR": {
      "1752": true
    },
    "RAMOS MEJIA": {
      "1704": true
    },
    "LA TABLADA": {
      "1766": true
    },
    "VILLA MADERO": {
      "1768": true
    },
    "MONTE CHINGOLO": {
      "1825": true
    },
    "VILLA JARDIN": {
      "1822": true
    },
    "VILLA POMPEO": {
      "1826": true
    },
    "VILLA INDUSTRIALES": {
      "1824": true
    },
    "LOMAS DE ZAMORA": {
      "1827": true,
      "1828": true,
      "1833": true
    },
    "VILLA HENZ": {
      "1836": true
    },
    "VILLA RITA": {
      "1832": true
    },
    "VILLA TURDERA": {
      "1834": true
    },
    "BARRIO SAN JOSE (PDO. LOMAS DE ZAMORA)": {
      "1835": true
    },
    "FIORITO": {
      "1831": true
    },
    "VILLA ALBERTINA": {
      "1829": true
    },
    "VILLA URBANA": {
      "1773": true
    },
    "BARRIO VILLA MARIA DE LOS REMEDIOS DE ESCALADA": {
      "1657": true
    },
    "VILLA LANZONI": {
      "1655": true
    },
    "VILLA MAIPU": {
      "1650": true
    },
    "VILLA ZAGALA": {
      "1651": true
    },
    "VILLA LYNCH (PDO. GRAL. SAN MARTIN)": {
      "1672": true
    },
    "VILLA BALLESTER": {
      "1653": true
    },
    "VILLA PARQUE": {
      "1678": true
    },
    "VILLA JOSE INGENIEROS": {
      "1702": true,
      "1703": true
    },
    "VILLA TALLERES ALIANZA": {
      "1676": true
    },
    "VILLA BOSCH": {
      "1682": true
    },
    "VILLA SAENZ PEÃA": {
      "1674": true
    },
    "EL PALOMAR": {
      "1684": true,
      "1685": true
    },
    "PUENTE SAAVEDRA": {
      "1602": true
    },
    "OLIVOS": {
      "1636": true
    },
    "CARAPACHAY": {
      "1606": true
    },
    "MUNRO": {
      "1605": true
    },
    "VICENTE LOPEZ": {
      "1604": true,
      "1638": true,
      "1652": true
    },
    "VILLA MARTELLI": {
      "1603": true
    },
    "JOSE MARMOL": {
      "1844": true,
      "1846": true
    },
    "VILLA PARIS": {
      "1856": true
    },
    "MINISTRO RIVADAVIA": {
      "1852": true
    },
    "VILLA LAURA (RAFAEL CALZADA-PDO. ALMTE. BROWN)": {
      "1847": true
    },
    "LONGCHAMPS": {
      "1854": true
    },
    "CLAYPOLE": {
      "1849": true
    },
    "BERAZATEGUI": {
      "1837": true,
      "1860": true,
      "1884": true,
      "1890": true,
      "1893": true
    },
    "VILLA REAL": {
      "1885": true
    },
    "VILLA GIAMBRUNO": {
      "1886": true
    },
    "VILLA TRANSRADIO": {
      "1776": true
    },
    "MONTE GRANDE": {
      "1841": true,
      "1842": true,
      "1851": true
    },
    "VILLA PARISH ROBERTSON": {
      "1838": true
    },
    "ESCOBAR": {
      "1625": true,
      "1628": true
    },
    "RUTA 26 MAQUINISTA FRANCISCO SAVIO": {
      "1619": true
    },
    "PUNTA DE CANAL (APEADERO FCGM)": {
      "1623": true
    },
    "MAQUINISTA FRANCISCO SAVIO": {
      "1620": true
    },
    "ZELAYA": {
      "1627": true
    },
    "COLONIA LOS CHIVATOS": {
      "1802": true
    },
    "VILLA GUILLERMINA": {
      "1804": true
    },
    "TRISTAN SUAREZ": {
      "1806": true
    },
    "CARLOS SPEGAZZINI": {
      "1812": true,
      "1813": true
    },
    "VILLA VATTEONE": {
      "1888": true
    },
    "VILLA HUDSON": {
      "1889": true
    },
    "INGENIERO ALLAN": {
      "1891": true
    },
    "WILLIAMS C. MORRIS (PARADA FCGSM)": {
      "1686": true
    },
    "TESEI": {
      "1688": true
    },
    "VILLA BARRIO ALTUBE": {
      "1665": true
    },
    "VILLA SANTA JULIA": {
      "1761": true
    },
    "TAPIALES": {
      "1770": true,
      "1792": true
    },
    "VILLA UNION": {
      "1757": true
    },
    "VILLA SCASSO": {
      "1759": true
    },
    "VIRREY DEL PINO": {
      "1763": true,
      "1764": true
    },
    "VILLA SAN ALBERTO (ISIDRO CASANOVA-PDO. LA MATANZA": {
      "1765": true
    },
    "VILLA CELINA": {
      "1762": true,
      "1767": true,
      "1772": true
    },
    "CIUDAD EVITA": {
      "1778": true
    },
    "RAFAEL CASTILLO": {
      "1755": true
    },
    "LA SALADA": {
      "1774": true
    },
    "ALDO BONZI": {
      "1771": true
    },
    "VILLA LUZURIAGA": {
      "1753": true,
      "1754": true
    },
    "KILOMETRO 30": {
      "1612": true
    },
    "TORTUGUITAS": {
      "1667": true
    },
    "KILOMETRO 38 (PDO. GRAL. SARMIENTO)": {
      "1615": true
    },
    "YAPEYU": {
      "1613": true
    },
    "VILLA DE MAYO": {
      "1614": true
    },
    "VILLA LAGO DEL BOSQUE": {
      "1722": true
    },
    "RUTA 200 KILOMETRO 38": {
      "1723": true
    },
    "VILLA MAGDALENA": {
      "1716": true
    },
    "SAN ANTONIO DE PADUA": {
      "1718": true
    },
    "VILLA ESCOBAR": {
      "1746": true
    },
    "VILLA MONSEGUR": {
      "1744": true
    },
    "VILLA GRAL. ZAPIOLA": {
      "1742": true
    },
    "TRUJUI": {
      "1664": true,
      "1736": true
    },
    "MORON": {
      "1482": true,
      "1708": true
    },
    "CASTELAR": {
      "1710": true,
      "1712": true
    },
    "MARIANO J. HAEDO": {
      "1706": true
    },
    "VILLA VERDE": {
      "1629": true
    },
    "VILLA DEL CARMEN (DEL VISO-PDO. GRAL. SARMIENTO)": {
      "1669": true
    },
    "VILLA ASTOLFI": {
      "1633": true
    },
    "TORO": {
      "1635": true
    },
    "VILLA ROSA": {
      "1630": true,
      "1631": true
    },
    "SAN FRANCISCO SOLANO": {
      "1843": true,
      "1881": true
    },
    "QUILMES OESTE": {
      "1879": true
    },
    "EZPELETA": {
      "1882": true
    },
    "VILLA MARIA (QUILMES-PDO. QUILMES)": {
      "1878": true
    },
    "DON BOSCO": {
      "1876": true,
      "1877": true
    },
    "ZANJA TAMAGNI": {
      "1649": true
    },
    "VIRREYES": {
      "1645": true,
      "1646": true
    },
    "VICTORIA": {
      "1644": true
    },
    "MARTINEZ": {
      "1640": true
    },
    "SAN ISIDRO": {
      "1642": true
    },
    "VILLA ADELINA": {
      "1607": true
    },
    "BECCAR": {
      "1643": true
    },
    "BOULOGNE SUR MER": {
      "1609": true
    },
    "SAN MIGUEL": {
      "1663": true
    },
    "ESCUELA SUBOFICIALES SARGENTO CABRAL (APEADERO FCGU)": {
      "1659": true
    },
    "TENIENTE GRAL. RICCHIERI": {
      "1661": true
    },
    "VILLA LAS TUNAS": {
      "1617": true
    },
    "VICEALMIRANTE E. MONTES": {
      "1611": true
    },
    "BENAVIDEZ": {
      "1621": true
    },
    "EL TALAR": {
      "1618": true
    },
    "NORDELTA": {
      "1670": true,
      "1671": true
    },
    "VILLA LA ÃATA": {
      "1648": true
    },
    "LOS TALAS": {
      "1923": true,
      "1942": true
    },
    "ISLA SANTIAGO": {
      "1929": true
    },
    "LA HORQUETA (PDO. CAMPANA)": {
      "2805": true
    },
    "RUTA 9 KILOMETRO 72": {
      "2804": true
    },
    "PAVON": {
      "2812": true
    },
    "VICENTE CASARES": {
      "1808": true
    },
    "MAXIMO PAZ": {
      "1809": true,
      "1814": true
    },
    "VILLA ADRIANA": {
      "1816": true
    },
    "URIBELARREA": {
      "1815": true
    },
    "CORONEL BRANDSEN": {
      "1918": true,
      "1986": true
    },
    "SAMBOROMBON": {
      "1980": true
    },
    "OLIDEN": {
      "1972": true,
      "1981": true
    },
    "GOMEZ DE LA VEGA": {
      "1983": true
    },
    "PUNTA LARA": {
      "1931": true
    },
    "PUERTO LA PLATA": {
      "1925": true
    },
    "ESCUELA NAVAL MILITAR RIO SANTIAGO": {
      "1927": true
    },
    "GOBERNADOR ANDONAEGUI": {
      "2764": true
    },
    "TORRES": {
      "6703": true
    },
    "LOS CARDALES": {
      "2714": true,
      "2814": true
    },
    "SPERATTI": {
      "1741": true
    },
    "PARADA KILOMETRO 76": {
      "1739": true
    },
    "LA CHOZA": {
      "1737": true
    },
    "VILLARS": {
      "1731": true
    },
    "PUEBLO NUEVO (GRAL. RODRIGUEZ-PDO. GRAL. RODRIGUEZ)": {
      "1748": true
    },
    "SAN PONCIANO": {
      "1903": true
    },
    "LA PLATA": {
      "1898": true,
      "1901": true,
      "1904": true,
      "1908": true,
      "1910": true,
      "1912": true,
      "1916": true,
      "1920": true
    },
    "IGNACIO CORREAS": {
      "1909": true
    },
    "LOS EUCALIPTOS": {
      "1895": true
    },
    "VILLA ELISA": {
      "1894": true
    },
    "RECREO VENECIA": {
      "1896": true
    },
    "TOLOSA": {
      "1900": true,
      "1906": true
    },
    "VILLA GARIBALDI": {
      "1907": true
    },
    "ISLA MARTIN GARCIA": {
      "1601": true
    },
    "POBLET": {
      "1905": true
    },
    "MANUEL B. GONNET": {
      "1897": true
    },
    "SANTA ELENA (LUJAN-PDO. LUJAN)": {
      "6700": true
    },
    "CARLOS KEEN": {
      "6701": true
    },
    "SUCRE": {
      "6708": true
    },
    "CORTINES": {
      "6712": true
    },
    "VILLA FRANCIA (VILLA FLANDRIA-PDO. LUJAN)": {
      "6706": true
    },
    "OLIVERA": {
      "6608": true
    },
    "ZAMUDIO (APEADERO FCDFS)": {
      "1727": true
    },
    "GUERNICA": {
      "1862": true
    },
    "VILLA NUMANCIA": {
      "1858": true
    },
    "EMPALME SAN VICENTE": {
      "1864": true
    },
    "HARAS RATAPLAN": {
      "1984": true
    },
    "SAN VICENTE": {
      "1865": true,
      "1866": true
    },
    "ESCALADA": {
      "2801": true
    },
    "ZARATE": {
      "2800": true,
      "6723": true
    },
    "RIO PARANA GUAZU": {
      "1647": true
    },
    "ATUCHA": {
      "2808": true
    },
    "LIMA": {
      "2806": true
    },
    "RIO LUJAN (PDO. CAMPANA)": {
      "2802": true
    },
    "GERLI (PARTIDO AVELLANEDA)": {
      "1869": true
    },
    "VILLA ESPAÃA": {
      "1880": true
    },
    "ITUZAINGO": {
      "1713": true,
      "1714": true,
      "1715": true
    },
    "VILLA RAFFO": {
      "1675": true
    },
    "ACASSUSO": {
      "1641": true
    },
    "MUÃIZ": {
      "1662": true
    },
    "GONZALEZ CATAN": {
      "1758": true
    },
    "LA LUCILA": {
      "1637": true
    },
    "ALMIRANTE BROWN": {
      "1845": true,
      "1848": true,
      "1850": true
    },
    "DOMINGO FAUSTINO SARMIENTO": {
      "1707": true
    },
    "MARTIN CORONADO": {
      "1683": true
    },
    "SANTA ROSA": {
      "1867": true
    },
    "CIUDADELA": {
      "1701": true
    },
    "9 DE ABRIL": {
      "1839": true
    },
    "LA REJA": {
      "1738": true
    },
    "BARRIO LA TABLADA": {
      "1751": true
    },
    "TIGRE": {
      "1610": true,
      "1622": true
    },
    "FRANCISCO ALVAREZ": {
      "1745": true
    },
    "RINCON DE MILBERG": {
      "1624": true
    },
    "Cuartel V": {
      "1740": true
    },
    "FLORENCIO VARELA": {
      "1818": true,
      "1853": true,
      "1859": true,
      "1863": true,
      "1887": true
    },
    "GRAND BOURG": {
      "1660": true
    },
    "ARTURO SEGUI": {
      "1985": true
    },
    "BARRIO EL JAGUEL": {
      "1805": true
    },
    "AVELLANEDA": {
      "1868": true,
      "1871": true,
      "1873": true
    },
    "LA PALA": {
      "1902": true
    },
    "EZEIZA": {
      "1775": true,
      "1801": true,
      "1803": true,
      "1807": true
    },
    "BERISSO": {
      "1914": true,
      "1924": true
    },
    "SAN JUSTO": {
      "1785": true
    },
    "HURLINGHAM": {
      "1681": true,
      "1689": true
    },
    "MALVINAS ARGENTINAS": {
      "1616": true
    },
    "PILAR": {
      "1516": true,
      "1632": true,
      "1634": true,
      "1639": true,
      "1666": true,
      "7110": true
    },
    "TRES DE FEBRERO": {
      "1658": true,
      "1687": true,
      "1692": true
    },
    "ENSENADA": {
      "1926": true
    },
    "BARRIO ESTEBAN ECHEVERRIA": {
      "2707": true
    },
    "EXALTACION DE LA CRUZ": {
      "2763": true,
      "6730": true,
      "6753": true
    },
    "GENERAL LAS HERAS": {
      "1733": true
    },
    "GENERAL RODRIGUEZ": {
      "1717": true,
      "1747": true,
      "1749": true,
      "1750": true
    },
    "LA MATANZA": {
      "1756": true,
      "1769": true,
      "1780": true,
      "1789": true
    },
    "LANUS": {
      "1820": true,
      "1823": true
    },
    "MERLO": {
      "1721": true,
      "1724": true
    },
    "MORENO": {
      "1743": true
    },
    "QUILMES": {
      "1840": true,
      "1855": true,
      "1883": true,
      "1892": true
    },
    "PLATANOS": {
      "1861": true
    },
    "BARRIO LOS TRONCOS DEL TALAR": {
      "1608": true
    },
    "BANFIELD": {
      "1821": true
    },
    "SAN MARTIN": {
      "1654": true,
      "1656": true
    },
    "BELEN DE ESCOBAR": {
      "1626": true,
      "1960": true
    },
    "JOSE C. PAZ": {
      "1690": true
    },
    "BARRIO CHURRUCA": {
      "1691": true
    },
    "BARRIO SANTA CLARA": {
      "1781": true
    },
    "MARCOS PAZ": {
      "1783": true,
      "1784": true,
      "1787": true,
      "1788": true,
      "1790": true,
      "1791": true,
      "1793": true
    },
    "20 DE JUNIO": {
      "1786": true
    },
    "ALEJANDRO PETION": {
      "1811": true
    },
    "PEREYRA (PDO. BERAZATEGUI)": {
      "1857": true
    },
    "MAGDALENA": {
      "1913": true
    },
    "VERONICA": {
      "1917": true
    },
    "PUNTA INDIO": {
      "1919": true,
      "1952": true
    },
    "ABASTO": {
      "1933": true
    },
    "ESTACION MORENO": {
      "1935": true
    },
    "ATALAYA": {
      "1947": true
    },
    "EMPALME MAGDALENA": {
      "1948": true
    },
    "PIPINAS": {
      "1954": true
    },
    "RANCHOS": {
      "1987": true
    },
    "VILLA TRINIDAD": {
      "2346": true
    },
    "PERGAMINO": {
      "2700": true,
      "2702": true
    },
    "RANCAGUA": {
      "2701": true,
      "2704": true
    },
    "CARABELAS": {
      "2703": true
    },
    "ROJAS": {
      "2705": true
    },
    "GUERRICO": {
      "2706": true,
      "2717": true
    },
    "LOS INDIOS": {
      "2709": true
    },
    "PEARSON": {
      "2711": true
    },
    "MANUEL OCAMPO": {
      "2713": true
    },
    "EL SOCORRO": {
      "2715": true,
      "7215": true
    },
    "MARIANO H. ALFONZO": {
      "2718": true
    },
    "COLON": {
      "2720": true
    },
    "SARASA": {
      "2721": true
    },
    "ARRECIFES": {
      "2740": true
    },
    "SALTO": {
      "2741": true
    },
    "ARROYO DULCE": {
      "2743": true
    },
    "GAHAN": {
      "2744": true,
      "2745": true
    },
    "INES INDART": {
      "2747": true
    },
    "LA VIOLETA": {
      "2751": true
    },
    "CAPITAN SARMIENTO": {
      "2752": true
    },
    "LA LUISA": {
      "2753": true
    },
    "TODD": {
      "2754": true
    },
    "VIÑA": {
      "2755": true
    },
    "SAN ANTONIO DE ARECO": {
      "2760": true
    },
    "VILLA LIA": {
      "2761": true
    },
    "ARROYO DE LA CRUZ": {
      "2813": true
    },
    "SAN NICOLAS DE LOS ARROYOS": {
      "2900": true,
      "2902": true
    },
    "LA EMILIA": {
      "2901": true
    },
    "CAMPO SALLES": {
      "2903": true
    },
    "GENERAL ROJO": {
      "2905": true
    },
    "GENERAL CONESA": {
      "2907": true
    },
    "MUTTI": {
      "2909": true
    },
    "SANCHEZ": {
      "2912": true
    },
    "VILLA GENERAL SAVIO": {
      "2913": true
    },
    "BARRIO D. ANTONIO": {
      "2914": true
    },
    "RAMALLO": {
      "2915": true
    },
    "EL PARAISO": {
      "2916": true
    },
    "SAN PEDRO": {
      "2930": true,
      "2931": true,
      "2938": true,
      "2943": true,
      "2944": true
    },
    "PEREZ MILLAN": {
      "2933": true
    },
    "SANTA LUCIA": {
      "2935": true
    },
    "BARADERO": {
      "2942": true
    },
    "GOBERNADOR CASTRO": {
      "2946": true
    },
    "JUNIN": {
      "6000": true,
      "6002": true
    },
    "AGUSTINA": {
      "6001": true,
      "6023": true
    },
    "ASCENSION": {
      "6003": true
    },
    "GENERAL ARENALES": {
      "6005": true
    },
    "ARRIBEÑOS": {
      "6007": true
    },
    "BAIGORRITA": {
      "6013": true
    },
    "GENERAL VIAMONTE": {
      "6015": true
    },
    "SAN EMILIO": {
      "6017": true,
      "6019": true
    },
    "ZAVALIA": {
      "6018": true
    },
    "LA ORIENTAL": {
      "6022": true
    },
    "FORTIN TIBURCIO": {
      "6024": true
    },
    "AGUSTIN ROCA": {
      "6026": true
    },
    "FERRE": {
      "6027": true
    },
    "VEDIA": {
      "6030": true
    },
    "DESVIO EL CHINGOLO": {
      "6031": true
    },
    "LEANDRO N ALEM": {
      "6032": true
    },
    "JUAN BAUTISTA ALBERDI": {
      "6034": true
    },
    "IRIARTE": {
      "6042": true
    },
    "IRALA": {
      "6047": true
    },
    "MORSE": {
      "6049": true
    },
    "GENERAL PINTO": {
      "6050": true
    },
    "PICHINCHA": {
      "6051": true
    },
    "GERMANIA": {
      "6053": true
    },
    "PAZOS KANKI": {
      "6058": true
    },
    "CORONEL GRANADA": {
      "6062": true
    },
    "PORVENIR": {
      "6063": true
    },
    "FLORENTINO AMEGHINO": {
      "6064": true
    },
    "BLAQUIER": {
      "6065": true
    },
    "LINCOLN": {
      "6070": true
    },
    "BERMUDEZ": {
      "6071": true
    },
    "EL TRIUNFO": {
      "6073": true
    },
    "ROBERTS": {
      "6075": true,
      "6079": true
    },
    "PASTEUR": {
      "6077": true
    },
    "BAYAUCA": {
      "6078": true
    },
    "LA CESIRA": {
      "6101": true
    },
    "GENERAL VILLEGAS": {
      "6230": true
    },
    "TRES ALGARROBOS": {
      "6231": true
    },
    "SANSINENA": {
      "6233": true
    },
    "AMERICA": {
      "6237": true
    },
    "GONZALEZ MORENO": {
      "6239": true
    },
    "PIEDRITAS": {
      "6241": true,
      "6249": true
    },
    "ELORDI": {
      "6242": true
    },
    "BANDERALO": {
      "6244": true
    },
    "QUENUMA": {
      "6335": true
    },
    "INGENIERO THOMPSON": {
      "6337": true
    },
    "LEUBUCO": {
      "6338": true
    },
    "SALLIQUELO": {
      "6339": true
    },
    "FRANCISCO MURATURE": {
      "6341": true
    },
    "MAZA": {
      "6343": true
    },
    "PELLEGRINI": {
      "6346": true
    },
    "DE BARY": {
      "6348": true
    },
    "TRENQUE LAUQUEN": {
      "6400": true
    },
    "SUNDBLAD": {
      "6401": true
    },
    "TREINTA DE AGOSTO": {
      "6405": true
    },
    "LA PORTEÑA": {
      "6407": true
    },
    "TRES LOMAS": {
      "6409": true
    },
    "GARRE": {
      "6411": true
    },
    "CASBAS": {
      "6417": true
    },
    "PRIMERA JUNTA": {
      "6422": true
    },
    "BERUTTI": {
      "6424": true
    },
    "CARHUE": {
      "6430": true
    },
    "ESTACION LAGO EPECUEY": {
      "6431": true
    },
    "ARTURO VATTEGNE": {
      "6433": true
    },
    "PALANTELEN": {
      "6434": true
    },
    "GUAMINI": {
      "6435": true
    },
    "ARROYO VENADO": {
      "6437": true
    },
    "MASUREL": {
      "6438": true
    },
    "BONIFACIO": {
      "6439": true
    },
    "RIVERA": {
      "6441": true
    },
    "ARANO": {
      "6443": true
    },
    "PEHUAJO": {
      "6450": true
    },
    "NUEVA PLATA": {
      "6451": true
    },
    "LAS TOSCAS": {
      "6453": true
    },
    "CARLOS TEJEDOR": {
      "6455": true
    },
    "TIMOTE": {
      "6457": true
    },
    "COLONIA SERE": {
      "6459": true
    },
    "LA COTORRA": {
      "6461": true
    },
    "ALAGON": {
      "6463": true
    },
    "HENDERSON": {
      "6465": true
    },
    "ENRIQUE LAVALLE": {
      "6467": true
    },
    "MONES CAZON": {
      "6469": true
    },
    "SALAZAR": {
      "6471": true
    },
    "FRANCISCO MADERO": {
      "6472": true
    },
    "JUAN JOSE PASO": {
      "6474": true
    },
    "ESTEBAN DE LUCA": {
      "6475": true
    },
    "GUANACO": {
      "6476": true
    },
    "9 DE JULIO": {
      "6500": true
    },
    "TROPEZON": {
      "6501": true
    },
    "PATRICIOS": {
      "6503": true
    },
    "DUDIGNAC": {
      "6505": true
    },
    "MOREA": {
      "6507": true
    },
    "DEL VALLE": {
      "6509": true
    },
    "HALE": {
      "6511": true
    },
    "LA NIÑA": {
      "6513": true
    },
    "CARLOS MARIA NAON": {
      "6515": true
    },
    "BACACAY": {
      "6516": true
    },
    "CARLOS CASARES": {
      "6530": true
    },
    "SMITH": {
      "6531": true
    },
    "MARTINEZ DE HOZ": {
      "6533": true
    },
    "BELLOCQ": {
      "6535": true
    },
    "ORDOQUI": {
      "6537": true
    },
    "LA DORITA": {
      "6538": true
    },
    "BOLIVAR": {
      "6550": true
    },
    "PIROVANO": {
      "6551": true
    },
    "URDAMPILLETA": {
      "6553": true
    },
    "DAIREAUX": {
      "6555": true
    },
    "ARBOLEDAS": {
      "6557": true,
      "6593": true
    },
    "RECALDE": {
      "6559": true
    },
    "BLANCAGRANDE": {
      "6561": true
    },
    "MERCEDES": {
      "6600": true,
      "6601": true,
      "6602": true,
      "6603": true,
      "6604": true,
      "6625": true,
      "6627": true,
      "6628": true,
      "6643": true,
      "7245": true,
      "7247": true,
      "7249": true,
      "7260": true,
      "7261": true
    },
    "NAVARRO": {
      "6605": true
    },
    "LAS MARIANAS": {
      "6607": true
    },
    "SUIPACHA": {
      "6612": true
    },
    "GENERAL RIVAS": {
      "6614": true
    },
    "CASTILLA": {
      "6616": true
    },
    "CHIVILCOY": {
      "6620": true,
      "6622": true
    },
    "GOBERNADOR UGARTE": {
      "6621": true
    },
    "LA RICA": {
      "6623": true
    },
    "GOROSTIAGA": {
      "6632": true
    },
    "ALBERTI": {
      "6634": true
    },
    "BRAGADO": {
      "6640": true
    },
    "COMODORO PY": {
      "6641": true
    },
    "LA LIMPIA": {
      "6645": true
    },
    "GENERAL O BRIEN": {
      "6646": true
    },
    "MECHITA": {
      "6648": true
    },
    "INGENIERO DE MADRID": {
      "6651": true
    },
    "OLASCOAGA": {
      "6652": true
    },
    "25 DE MAYO": {
      "6660": true
    },
    "LUCAS MONTEVERDE": {
      "6661": true
    },
    "NORBERTO DE LA RIESTRA": {
      "6663": true
    },
    "PEDERNALES": {
      "6665": true
    },
    "VALDES": {
      "6667": true
    },
    "LUJAN": {
      "6702": true,
      "6709": true
    },
    "VILLA RUIZ": {
      "6705": true
    },
    "SAN ANDRES DE GILES": {
      "6720": true
    },
    "AZCUENAGA": {
      "6721": true
    },
    "CARMEN DE ARECO": {
      "6725": true
    },
    "TRES SARGENTOS": {
      "6727": true
    },
    "RAWSON": {
      "6734": true
    },
    "CHACABUCO": {
      "6740": true
    },
    "COLIQUEO": {
      "6743": true
    },
    "CUCHA CUCHA": {
      "6746": true
    },
    "O HIGGINS": {
      "6748": true
    },
    "TANDIL": {
      "7000": true
    },
    "LA PASTORA": {
      "7001": true
    },
    "VELA": {
      "7003": true
    },
    "BARKER": {
      "7005": true,
      "7033": true
    },
    "NAPALEOFU": {
      "7007": true
    },
    "IRAOLA": {
      "7009": true
    },
    "JUAN N FERNANDEZ": {
      "7011": true
    },
    "DE LA CANAL": {
      "7013": true
    },
    "BENITO JUAREZ": {
      "7020": true
    },
    "LOPEZ": {
      "7021": true
    },
    "DOLORES": {
      "7100": true
    },
    "CEVIGNE": {
      "7101": true
    },
    "COSTA AZUL": {
      "7102": true
    },
    "GENERAL LAVALLE": {
      "7103": true
    },
    "COSTA DEL ESTE": {
      "7104": true
    },
    "SAN CLEMENTE DEL TUYU": {
      "7105": true
    },
    "LAS TONINAS": {
      "7106": true
    },
    "SANTA TERESITA": {
      "7107": true
    },
    "MAR DEL TUYU": {
      "7108": true
    },
    "MAR DE AJO": {
      "7109": true
    },
    "SAN BERNARDO DEL TUYU": {
      "7111": true
    },
    "AGUAS VERDES": {
      "7112": true
    },
    "LA LUCILA DEL MAR": {
      "7113": true
    },
    "CASTELLI": {
      "7114": true
    },
    "CHASCOMUS": {
      "7116": true,
      "7130": true,
      "7135": true,
      "7136": true
    },
    "GENERAL GUIDO": {
      "7118": true
    },
    "CARI LARQUEA": {
      "7119": true
    },
    "AYACUCHO": {
      "7150": true
    },
    "UDAQUIOLA": {
      "7151": true
    },
    "FAIR": {
      "7153": true
    },
    "MAIPU": {
      "7160": true,
      "7162": true
    },
    "LABARDEN": {
      "7161": true
    },
    "GENERAL MADARIAGA": {
      "7163": true
    },
    "OSTENDE": {
      "7164": true
    },
    "VILLA GESELL": {
      "7165": true
    },
    "VALERIA DEL MAR": {
      "7166": true
    },
    "PINAMAR": {
      "7167": true
    },
    "JUANCHO": {
      "7169": true
    },
    "GENERAL PIRAN": {
      "7172": true
    },
    "CORONEL VIDAL": {
      "7174": true
    },
    "LAS ARMAS": {
      "7176": true
    },
    "LAS FLORES": {
      "7200": true
    },
    "COLMAN": {
      "7201": true
    },
    "RAUCH": {
      "7203": true
    },
    "ROSAS": {
      "7205": true
    },
    "EL TRIGO": {
      "7207": true
    },
    "VILELA": {
      "7208": true
    },
    "PARDO": {
      "7212": true
    },
    "CACHARI": {
      "7214": true
    },
    "SAN MIGUEL DEL MONTE": {
      "7220": true
    },
    "GOBERNADOR UDAONDO": {
      "7221": true
    },
    "GENERAL BELGRANO": {
      "7223": true
    },
    "VILLANUEVA": {
      "7225": true
    },
    "ZENON VIDELA DORNA": {
      "7226": true
    },
    "ABBOTT": {
      "7228": true
    },
    "LOBOS": {
      "7240": true,
      "7420": true
    },
    "SALVADOR MARIA": {
      "7241": true
    },
    "ELVIRA": {
      "7243": true
    },
    "GENERAL ALVEAR": {
      "7263": true
    },
    "DEL CARRIL": {
      "7265": true
    },
    "POLVAREDAS": {
      "7267": true
    },
    "AZUL": {
      "7300": true
    },
    "ARROYO DE LOS HUESOS": {
      "7301": true
    },
    "TAPALQUE": {
      "7303": true
    },
    "VELLOSO": {
      "7305": true
    },
    "CROTTO": {
      "7307": true
    },
    "CHILLAR": {
      "7311": true
    },
    "16 DE JULIO": {
      "7313": true
    },
    "LAS NIEVES": {
      "7316": true
    },
    "HINOJO": {
      "7318": true
    },
    "OLAVARRIA": {
      "7400": true
    },
    "SIERRA CHICA": {
      "7401": true
    },
    "LOMA NEGRA": {
      "7403": true,
      "7436": true
    },
    "SAN JORGE": {
      "7404": true
    },
    "GENERAL LAMADRID": {
      "7406": true
    },
    "LIBANO": {
      "7407": true
    },
    "LA COLINA": {
      "7408": true
    },
    "VOLUNTAD": {
      "7412": true
    },
    "LAPRIDA": {
      "7414": true
    },
    "TRES ARROYOS": {
      "7500": true
    },
    "INDIO RICO": {
      "7501": true
    },
    "ORENSE": {
      "7503": true
    },
    "BALNEARIO CLAROMECO": {
      "7505": true
    },
    "MICAELA CASCALLARES": {
      "7507": true
    },
    "ORIENTE": {
      "7509": true
    },
    "COPETONAS": {
      "7511": true
    },
    "ADOLFO GONZALES CHAVES": {
      "7513": true
    },
    "DE LA GARMA": {
      "7515": true
    },
    "JUAN E BARRA": {
      "7517": true
    },
    "SAN MAYOL": {
      "7519": true
    },
    "SAN CAYETANO": {
      "7521": true
    },
    "CORONEL PRINGLES": {
      "7530": true
    },
    "EL PENSAMIENTO": {
      "7531": true
    },
    "QUIÑIHUAL ESTACION": {
      "7533": true
    },
    "PONTAUT": {
      "7535": true
    },
    "LA RESERVA": {
      "7536": true
    },
    "CORONEL SUAREZ": {
      "7540": true
    },
    "PUEBLO SAN JOSE": {
      "7541": true
    },
    "LA PRIMAVERA": {
      "7543": true
    },
    "HUANGUELEN": {
      "7545": true
    },
    "PASMAN": {
      "7547": true
    },
    "CURAMALAN": {
      "7548": true
    },
    "PUEBLO SANTA MARIA": {
      "7569": true
    },
    "SANTA TRINIDAD": {
      "7570": true
    },
    "MAR DEL PLATA": {
      "7600": true,
      "7602": true,
      "7603": true,
      "7604": true,
      "7606": true,
      "7608": true,
      "7610": true,
      "7611": true
    },
    "BARRIO BATAN": {
      "7601": true
    },
    "CHAPADMALAL": {
      "7605": true,
      "7619": true
    },
    "MIRAMAR": {
      "7607": true
    },
    "SANTA CLARA DEL MAR": {
      "7609": true
    },
    "VIVORATA": {
      "7612": true
    },
    "NAHUEL RUCA": {
      "7613": true
    },
    "BALCARCE": {
      "7620": true
    },
    "RAMOS OTERO": {
      "7621": true
    },
    "LOS PINOS": {
      "7623": true
    },
    "NECOCHEA": {
      "7630": true,
      "7632": true
    },
    "QUEQUEN": {
      "7631": true
    },
    "TAMANGUEYU": {
      "7633": true
    },
    "LOBERIA": {
      "7635": true
    },
    "LA DULCE": {
      "7637": true
    },
    "COOPER": {
      "7639": true
    },
    "ENERGIA": {
      "7640": true,
      "7641": true
    },
    "BAHIA BLANCA": {
      "8000": true,
      "8001": true,
      "8002": true,
      "8003": true,
      "8049": true,
      "8100": true
    },
    "CHASICO": {
      "8017": true
    },
    "ARIAS": {
      "8101": true
    },
    "INGENIERO WHITE": {
      "8103": true
    },
    "GENERAL DANIEL CERRI": {
      "8105": true
    },
    "COMANDANTE ESPORA": {
      "8107": true
    },
    "PUNTA ALTA": {
      "8109": true
    },
    "PUERTO BELGRANO": {
      "8111": true
    },
    "BATERIAS": {
      "8113": true
    },
    "BAJO HONDO": {
      "8115": true
    },
    "ALFEREZ SAN MARTIN": {
      "8117": true
    },
    "CABILDO": {
      "8118": true
    },
    "PUAN": {
      "8120": true,
      "8180": true
    },
    "LA VITICOLA": {
      "8122": true
    },
    "BERRAONDO": {
      "8124": true
    },
    "VILLA IRIS": {
      "8126": true
    },
    "ESTELA": {
      "8127": true
    },
    "17 DE AGOSTO": {
      "8129": true,
      "8225": true
    },
    "MEDANOS": {
      "8132": true
    },
    "ARGERICH": {
      "8134": true
    },
    "ALGARROBO": {
      "8136": true
    },
    "HILARIO ASCASUBI": {
      "8142": true
    },
    "TENIENTE ORIGONE": {
      "8144": true
    },
    "MAYOR BURATOVICH": {
      "8146": true
    },
    "PEDRO LURO": {
      "8148": true
    },
    "CORONEL DORREGO": {
      "8150": true
    },
    "GIL": {
      "8151": true
    },
    "MONTE HERMOSO": {
      "8153": true
    },
    "SAN ROMAN": {
      "8154": true
    },
    "JOSE A GUISASOLA": {
      "8156": true
    },
    "APARICIO": {
      "8158": true
    },
    "TORNQUIST": {
      "8160": true
    },
    "TRES PICOS": {
      "8162": true
    },
    "DUFAUR": {
      "8164": true
    },
    "SALDUNGARAY": {
      "8166": true
    },
    "SIERRA DE LA VENTANA": {
      "8168": true
    },
    "PIGUE": {
      "8170": true
    },
    "ESPARTILLAR": {
      "8171": true
    },
    "ARROYO CORTO": {
      "8172": true
    },
    "SAAVEDRA": {
      "8174": true
    },
    "GOYENA": {
      "8175": true
    },
    "AZOPARDO": {
      "8181": true
    },
    "DARREGUEIRA": {
      "8183": true
    },
    "ESTEBAN A. GASCON": {
      "8185": true
    },
    "BORDENAVE": {
      "8187": true
    },
    "CARMEN DE PATAGONES": {
      "8504": true
    },
    "CARDENAL CAGLIERO": {
      "8506": true
    },
    "STROEDER": {
      "8508": true
    },
    "VILLALONGA": {
      "8512": true
    },
    "QUIROGA": {
      "6560": true
    },
    "JUAN A. PRADERE": {
      "8255": true
    },
    "ATLANTIDA": {
      "7807": true
    },
    "SIERRA DE LOS PADRES": {
      "7627": true
    },
    "BALNEARIO CAMET NORTE": {
      "7803": true
    },
    "NUEVA ATLANTIS": {
      "7124": true
    },
    "LUIS GUILLON": {
      "1777": true
    },
    "PLA": {
      "6691": true
    },
    "WARNES": {
      "6637": true
    },
    "LAGUNA ALSINA": {
      "6477": true
    }
  },
  "SANTA FE": {
    "ROSARIO": {
      "2000": true,
      "2001": true,
      "2002": true,
      "2003": true,
      "2004": true,
      "2005": true,
      "2006": true,
      "2007": true,
      "2008": true,
      "2009": true,
      "2010": true,
      "2011": true,
      "2012": true,
      "2013": true,
      "2014": true,
      "2015": true,
      "2108": true,
      "2127": true,
      "2130": true,
      "2610": true
    },
    "ALBARELLOS": {
      "2101": true
    },
    "VILLA AMELIA": {
      "2102": true
    },
    "CORONEL BOGADO": {
      "2103": true
    },
    "JUAN B MOLINA": {
      "2104": true
    },
    "SARGENTO CABRAL": {
      "2105": true,
      "2106": true
    },
    "ALVAREZ": {
      "2107": true
    },
    "ACEBAL": {
      "2109": true
    },
    "PAVON ARRIBA": {
      "2110": true
    },
    "SANTA TERESA": {
      "2111": true
    },
    "URANGA": {
      "2112": true
    },
    "PEYRANO": {
      "2113": true
    },
    "CORONEL DOMINGUEZ": {
      "2114": true
    },
    "MAXIMO PAZ": {
      "2115": true
    },
    "ALCORTA": {
      "2117": true
    },
    "EMPALME VILLA CONSTITUCION": {
      "2118": true,
      "2918": true
    },
    "ERASTO": {
      "2119": true
    },
    "PUEBLO MUÑOZ": {
      "2120": true
    },
    "PEREZ": {
      "2121": true
    },
    "PUJATO": {
      "2122": true,
      "2323": true
    },
    "FUENTES": {
      "2123": true
    },
    "VILLA GOBERNADOR GALVEZ": {
      "2124": true
    },
    "ZAVALLA": {
      "2125": true
    },
    "FIGHIERA": {
      "2126": true
    },
    "ARROYO SECO": {
      "2128": true
    },
    "PUEBLO ESTHER": {
      "2129": true
    },
    "CNEL ARNOLD": {
      "2131": true
    },
    "FUNES": {
      "2132": true
    },
    "LA VANGUARDIA": {
      "2133": true
    },
    "ROLDAN": {
      "2134": true
    },
    "CARMEN DEL SAUCE": {
      "2135": true
    },
    "CORREA": {
      "2136": true,
      "2506": true
    },
    "CARCARAÑA": {
      "2138": true
    },
    "CHAÑAR LADEADO": {
      "2139": true
    },
    "LA SALADA": {
      "2141": true
    },
    "IBARLUCEA": {
      "2142": true,
      "2143": true
    },
    "TOTORAS": {
      "2144": true
    },
    "CLASON": {
      "2146": true,
      "2151": true
    },
    "SAN GENARO": {
      "2147": true
    },
    "CENTENO": {
      "2148": true
    },
    "CASAS": {
      "2149": true
    },
    "LUCIO V LOPEZ": {
      "2150": true
    },
    "GRANADERO BAIGORRIA": {
      "2152": true
    },
    "LAS BANDURRIAS": {
      "2153": true
    },
    "CAPITAN BERMUDEZ": {
      "2154": true
    },
    "FRAY LUIS BELTRAN": {
      "2156": true,
      "2158": true
    },
    "CASILDA": {
      "2170": true
    },
    "CHABAS": {
      "2173": true
    },
    "SANFORD": {
      "2174": true
    },
    "VILLA MUGUETA": {
      "2175": true
    },
    "VILLADA": {
      "2176": true
    },
    "BIGAND": {
      "2177": true
    },
    "BOMBAL": {
      "2179": true
    },
    "LOS MOLINOS": {
      "2181": true
    },
    "AREQUITO": {
      "2183": true
    },
    "LOS NOGALES": {
      "2184": true
    },
    "SAN JOSE DE LA ESQUINA": {
      "2185": true,
      "2186": true
    },
    "ARTEAGA": {
      "2187": true
    },
    "SAN LORENZO": {
      "2200": true
    },
    "RICARDONE": {
      "2201": true
    },
    "PUERTO GRAL SAN MARTIN": {
      "2202": true
    },
    "TIMBUES": {
      "2204": true
    },
    "OLIVEROS": {
      "2206": true
    },
    "MACIEL": {
      "2208": true,
      "2209": true
    },
    "MONJE": {
      "2212": true
    },
    "ALDAO": {
      "2214": true
    },
    "ANDINO": {
      "2215": true
    },
    "SERODINO": {
      "2216": true
    },
    "CLARKE": {
      "2218": true
    },
    "DIAZ": {
      "2222": true
    },
    "PINZON": {
      "2223": true
    },
    "CORONDA": {
      "2240": true
    },
    "LARRECHEA": {
      "2241": true
    },
    "DESVIO ARIJON": {
      "2242": true
    },
    "SAN FABIAN": {
      "2243": true
    },
    "AROCENA": {
      "2244": true
    },
    "BARRIO CAIMA": {
      "2245": true
    },
    "BARRANCAS": {
      "2246": true
    },
    "BERNARDO DE IRIGOYEN": {
      "2248": true
    },
    "IRIGOYEN": {
      "2249": true
    },
    "GALVEZ": {
      "2252": true
    },
    "LOMA ALTA": {
      "2253": true
    },
    "GESSLER": {
      "2254": true
    },
    "LOPEZ": {
      "2255": true
    },
    "SAN EUGENIO": {
      "2256": true
    },
    "COLONIA BELGRANO": {
      "2257": true
    },
    "SANTA CLARA DE BUENA VISTA": {
      "2258": true
    },
    "RAFAELA": {
      "2300": true
    },
    "BELLA ITALIA": {
      "2301": true
    },
    "SUSANA": {
      "2302": true
    },
    "ANGELICA": {
      "2303": true
    },
    "LEHMANN": {
      "2305": true
    },
    "VILA": {
      "2306": true
    },
    "GALISTEO": {
      "2307": true
    },
    "HUMBERTO PRIMERO": {
      "2309": true
    },
    "COLONIA CASTELLANOS": {
      "2310": true
    },
    "CAPIVA": {
      "2311": true
    },
    "COLONIA SAN ANTONIO": {
      "2312": true
    },
    "MOISES VILLE": {
      "2313": true
    },
    "ESTACION SAGUIER": {
      "2315": true
    },
    "CASABLANCA": {
      "2317": true
    },
    "AURELIA SUD": {
      "2318": true
    },
    "EGUSQUIZA": {
      "2319": true
    },
    "PUEBLO SAN ANTONIO": {
      "2320": true
    },
    "SAGUIER": {
      "2321": true
    },
    "SUNCHALES": {
      "2322": true
    },
    "TACURAL": {
      "2324": true
    },
    "NUEVA LEHMANN": {
      "2326": true
    },
    "EUSEBIA": {
      "2330": true
    },
    "LA CORTADERA": {
      "2334": true
    },
    "AMBROSETTI": {
      "2339": true,
      "2352": true
    },
    "CERES": {
      "2340": true
    },
    "LA RUBIA": {
      "2342": true,
      "2350": true
    },
    "LA GERALDINA": {
      "2343": true
    },
    "ARRUFO": {
      "2344": true
    },
    "VILLA TRINIDAD": {
      "2345": true
    },
    "COLONIA ROSA": {
      "2347": true,
      "2351": true
    },
    "MONIGOTES": {
      "2348": true
    },
    "ESTACION JOSEFINA": {
      "2403": true
    },
    "COLONIA JOSEFINA": {
      "2404": true
    },
    "SANTA CLARA DE SAGUIER": {
      "2405": true
    },
    "CLUCELLAS": {
      "2407": true
    },
    "ESTACION CLUCELLAS": {
      "2408": true
    },
    "ZENON PEREYRA": {
      "2409": true
    },
    "FRONTERA": {
      "2438": true
    },
    "SASTRE": {
      "2440": true
    },
    "CRISPI": {
      "2441": true
    },
    "GARIBALDI": {
      "2443": true
    },
    "MARIA JUANA": {
      "2445": true
    },
    "PUEBLO MARIA JUANA": {
      "2446": true
    },
    "SAN VICENTE": {
      "2447": true
    },
    "SAN MARTIN DE LAS ESCOBAS": {
      "2449": true
    },
    "SAN JORGE": {
      "2451": true,
      "2452": true
    },
    "CARLOS PELLEGRINI": {
      "2453": true
    },
    "CAÑADA ROSQUIN": {
      "2454": true
    },
    "ESMERALDA": {
      "2456": true
    },
    "CANDIOTI": {
      "2469": true,
      "3018": true
    },
    "COSTA DEL TOBA": {
      "2494": true
    },
    "SANTA FELICIA": {
      "2495": true
    },
    "CAÑADA DE GOMEZ": {
      "2500": true
    },
    "BERRETTA": {
      "2501": true
    },
    "MARIA LUISA CORREA": {
      "2502": true
    },
    "VILLA ELOISA": {
      "2503": true
    },
    "BUSTINZA": {
      "2504": true
    },
    "LAS PAREJAS": {
      "2505": true
    },
    "ARMSTRONG": {
      "2508": true
    },
    "TORTUGAS": {
      "2512": true
    },
    "LAS ROSAS": {
      "2520": true
    },
    "MONTES DE OCA": {
      "2521": true
    },
    "BOUQUET": {
      "2523": true
    },
    "MARIA SUSANA": {
      "2527": true
    },
    "PIAMONTE": {
      "2529": true
    },
    "LANDETA": {
      "2531": true
    },
    "LOS CARDOS": {
      "2533": true
    },
    "EL TREBOL": {
      "2534": true,
      "2535": true
    },
    "LOS QUIRQUINCHOS": {
      "2537": true,
      "2637": true
    },
    "ORDOÑEZ": {
      "2595": true
    },
    "VENADO TUERTO": {
      "2600": true
    },
    "MURPHY": {
      "2601": true
    },
    "LA CHISPA": {
      "2602": true
    },
    "CHAPUY": {
      "2603": true
    },
    "SAN FRANCISCO DE SANTA FE": {
      "2604": true
    },
    "SANTA ISABEL": {
      "2605": true
    },
    "VILLA CAÑAS": {
      "2607": true
    },
    "MARIA TERESA": {
      "2609": true
    },
    "RUNCIMAN": {
      "2611": true
    },
    "SAN GREGORIO": {
      "2613": true
    },
    "SAN EDUARDO": {
      "2615": true
    },
    "SANCTI SPIRITU": {
      "2617": true
    },
    "CARMEN": {
      "2618": true
    },
    "MAGGIOLO": {
      "2622": true
    },
    "FIRMAT": {
      "2630": true
    },
    "PUEBLO MIGUEL TORRES": {
      "2631": true
    },
    "CHOVET": {
      "2633": true
    },
    "CAÑADA DEL UCLE": {
      "2635": true
    },
    "BERABEVU": {
      "2639": true
    },
    "Godeken": {
      "2640": true
    },
    "CAFFERATA": {
      "2643": true
    },
    "WHEELWRIGHT": {
      "2722": true
    },
    "JUNCAL": {
      "2723": true
    },
    "URQUIZA": {
      "2724": true
    },
    "HUGHES": {
      "2725": true
    },
    "LABORDEBOY": {
      "2726": true
    },
    "MELINCUE": {
      "2728": true
    },
    "CARRERAS": {
      "2729": true
    },
    "ELORTONDO": {
      "2732": true
    },
    "VILLA CONSTITUCION": {
      "2919": true
    },
    "PAVON": {
      "2920": true
    },
    "RUEDA": {
      "2921": true,
      "2923": true
    },
    "THEOBALD": {
      "2922": true
    },
    "SANTA FE": {
      "3000": true,
      "3002": true,
      "3004": true,
      "3006": true,
      "3008": true,
      "3012": true,
      "3015": true,
      "3088": true
    },
    "COLASTINE": {
      "3001": true
    },
    "HELVECIA": {
      "3003": true
    },
    "SAN JAVIER": {
      "3005": true
    },
    "EMPALME SAN CARLOS": {
      "3007": true
    },
    "FRANCK": {
      "3009": true
    },
    "EL TROPEZON": {
      "3010": true
    },
    "SAN GERONIMO NORTE": {
      "3011": true
    },
    "SAN CARLOS CENTRO": {
      "3013": true
    },
    "ANGEL GALLARDO": {
      "3014": true
    },
    "SANTO TOME": {
      "3016": true
    },
    "SAUCE VIEJO": {
      "3017": true,
      "3034": true
    },
    "SAN AGUSTIN": {
      "3019": true
    },
    "LAGUNA PAIVA": {
      "3020": true
    },
    "CAMPO ANDINO": {
      "3021": true
    },
    "SANTA ROSA DE CALCHINES": {
      "3022": true
    },
    "HIPATIA": {
      "3023": true,
      "3049": true
    },
    "SARMIENTO": {
      "3024": true
    },
    "COLONIA CLARA": {
      "3025": true
    },
    "LA PELADA": {
      "3027": true
    },
    "MARIA LUISA": {
      "3028": true
    },
    "ELISA": {
      "3029": true
    },
    "MONTE VERA": {
      "3030": true
    },
    "ARROYO AGUIAR": {
      "3031": true
    },
    "NELSON": {
      "3032": true
    },
    "LAS TUNAS": {
      "3033": true
    },
    "EMILIA": {
      "3036": true,
      "3092": true
    },
    "CAYASTACITO": {
      "3038": true
    },
    "MARIANO SAAVEDRA": {
      "3039": true
    },
    "SAN JUSTO": {
      "3040": true
    },
    "LOS SALADILLOS": {
      "3041": true
    },
    "MARCELINO ESCALADA": {
      "3042": true
    },
    "GOBERNADOR CRESPO": {
      "3044": true
    },
    "COLONIA LA PENCA": {
      "3045": true
    },
    "PETRONILLA": {
      "3046": true
    },
    "VIDELA": {
      "3048": true
    },
    "CALCHAQUI": {
      "3050": true
    },
    "ALEJANDRA": {
      "3051": true
    },
    "LA CRIOLLA": {
      "3052": true
    },
    "PERICOTA": {
      "3053": true
    },
    "VERA Y PINTADO": {
      "3054": true
    },
    "MARGARITA": {
      "3056": true
    },
    "LA GALLARETA": {
      "3057": true
    },
    "VUELTA DEL PIRATA": {
      "3058": true
    },
    "INDEPENDENCIA": {
      "3060": true
    },
    "ANTONIO PINI": {
      "3061": true
    },
    "LOGROÑO": {
      "3066": true,
      "3075": true
    },
    "POZO BORRADO": {
      "3067": true
    },
    "SANTA MARGARITA": {
      "3068": true
    },
    "GREGORIA PEREZ DE DENIS": {
      "3069": true
    },
    "SAN CRISTOBAL": {
      "3070": true
    },
    "AGUARA GRANDE": {
      "3071": true
    },
    "ÑANDUCITA": {
      "3072": true
    },
    "LA CABRAL": {
      "3074": true
    },
    "HUANQUEROS": {
      "3076": true
    },
    "ESTEBAN RAMS": {
      "3077": true
    },
    "ESPERANZA": {
      "3080": true
    },
    "CAVOUR": {
      "3081": true,
      "3082": true
    },
    "GRUTLY": {
      "3083": true
    },
    "FELICIA": {
      "3087": true
    },
    "SAN JOSE DEL RINCON": {
      "3089": true
    },
    "CABAL": {
      "3091": true
    },
    "RAMAYON": {
      "3094": true
    },
    "KILOMETRO 302": {
      "3097": true
    },
    "FLORENCIA": {
      "3516": true
    },
    "VERA": {
      "3550": true
    },
    "TOBA": {
      "3551": true
    },
    "INTIYACO": {
      "3552": true
    },
    "SANTA LUCIA": {
      "3553": true
    },
    "LAS PALMAS": {
      "3555": true
    },
    "CARAGUATAY": {
      "3557": true
    },
    "RECONQUISTA": {
      "3560": true
    },
    "AVELLANEDA": {
      "3561": true
    },
    "FORTIN OLMOS": {
      "3562": true
    },
    "COLONIA SAN MANUEL": {
      "3563": true
    },
    "EL TAJAMAR": {
      "3565": true
    },
    "LA LOLA": {
      "3567": true
    },
    "BERNA": {
      "3569": true
    },
    "MALABRIGO": {
      "3572": true
    },
    "GUADALUPE NORTE": {
      "3574": true
    },
    "ARROYO CEIBAL": {
      "3575": true
    },
    "LANTERI": {
      "3576": true
    },
    "LAS GARZAS": {
      "3577": true
    },
    "VILLA OCAMPO": {
      "3580": true
    },
    "VILLA ADELA": {
      "3581": true,
      "3596": true
    },
    "VILLA ANA": {
      "3583": true
    },
    "LOS LAURELES": {
      "3584": true
    },
    "EL SOMBRERITO": {
      "3585": true
    },
    "LAS TOSCAS": {
      "3586": true
    },
    "TACUARENDI": {
      "3587": true,
      "3588": true
    },
    "VILLA GUILLERMINA": {
      "3589": true
    },
    "EL RABON": {
      "3592": true
    },
    "TEODELINA": {
      "6009": true
    },
    "DIEGO DE ALVEAR": {
      "6036": true
    },
    "christophersen": {
      "6039": true
    },
    "RUFINO": {
      "6100": true
    },
    "AMENABAR": {
      "6103": true
    },
    "CAÑADA SECA": {
      "6105": true
    },
    "ARON CASTELLANOS": {
      "6106": true
    },
    "SANTA REGINA": {
      "6107": true
    }
  },
  "ENTRE RIOS": {
    "CHARIGUE": {
      "2100": true
    },
    "GUALEGUAYCHU": {
      "2820": true,
      "2822": true
    },
    "GUALEYAN": {
      "2821": true
    },
    "CEIBAS": {
      "2823": true
    },
    "GENERAL ALMADA": {
      "2824": true
    },
    "URDINARRAIN": {
      "2826": true
    },
    "ALDEA SAN ANTONIO": {
      "2827": true
    },
    "COLONIA NUEVA MONTEVIDEO": {
      "2828": true
    },
    "GUALEGUAY": {
      "2840": true
    },
    "ALDEA ASUNCION": {
      "2841": true
    },
    "GENERAL GALARZA": {
      "2843": true
    },
    "GOBERNADOR MANSILLA": {
      "2845": true
    },
    "IBICUY": {
      "2846": true
    },
    "GOBERNADOR ECHAGUE": {
      "2847": true
    },
    "MEDANOS": {
      "2848": true
    },
    "IRAZUSTA ESTACION": {
      "2851": true
    },
    "ENRIQUE CARBO": {
      "2852": true
    },
    "LARROQUE": {
      "2854": true
    },
    "PARANA": {
      "3100": true,
      "3102": true,
      "3104": true,
      "3106": true,
      "3108": true,
      "3141": true
    },
    "ALDEA SPATZENKUTTER": {
      "3101": true
    },
    "PUIGARI": {
      "3103": true
    },
    "DIAMANTE": {
      "3105": true
    },
    "SAN BENITO": {
      "3107": true,
      "3120": true
    },
    "EL RAMBLON": {
      "3109": true
    },
    "TABOSSI": {
      "3111": true,
      "3124": true
    },
    "COLONIA LOMA NEGRA": {
      "3112": true
    },
    "VILLA URQUIZA": {
      "3113": true,
      "3126": true
    },
    "COLIONIA MARIA LUISA": {
      "3114": true
    },
    "ALDEA PROTESTANTE": {
      "3115": true
    },
    "CRESPO": {
      "3116": true
    },
    "SEGUI": {
      "3117": true
    },
    "LA PICADA": {
      "3118": true
    },
    "COLONIA CERRITO": {
      "3122": true
    },
    "ALDEA SANTA MARIA": {
      "3123": true
    },
    "PUEBLO BRUGO": {
      "3125": true
    },
    "HERNANDARIAS": {
      "3127": true
    },
    "COLONIA BERRO": {
      "3128": true
    },
    "PIEDRAS BLANCAS": {
      "3129": true
    },
    "GENERAL RACEDO": {
      "3130": true
    },
    "TEZANOS PINTO": {
      "3131": true
    },
    "EL PINGO": {
      "3132": true
    },
    "MARIA GRANDE": {
      "3133": true
    },
    "HASENKAMP": {
      "3134": true
    },
    "ALDEA SAN RAFAEL": {
      "3135": true
    },
    "PUEBLO BELLOCQ": {
      "3136": true
    },
    "EL SOLAR": {
      "3137": true
    },
    "ALCARAZ 2DO": {
      "3138": true
    },
    "BOVRIL": {
      "3142": true
    },
    "SAUCE DE LUNA": {
      "3144": true
    },
    "LUCAS GONZALEZ": {
      "3145": true,
      "3158": true
    },
    "NOGOYA": {
      "3150": true
    },
    "CRUCESITAS": {
      "3151": true
    },
    "SAUCE": {
      "3152": true
    },
    "VICTORIA": {
      "3153": true
    },
    "LAGUNA DEL PESCADO": {
      "3155": true
    },
    "BETBEDER": {
      "3156": true
    },
    "ARANGUREN": {
      "3162": true
    },
    "GENERAL RAMIREZ": {
      "3164": true
    },
    "EL MARTILLO": {
      "3166": true
    },
    "BASAVILBASO": {
      "3170": true
    },
    "ROCAMORA": {
      "3172": true
    },
    "ROSARIO DEL TALA": {
      "3174": true
    },
    "CRUCECITAS 8A SECCION": {
      "3175": true
    },
    "SOLA": {
      "3176": true
    },
    "MACIA": {
      "3177": true
    },
    "DURAZNO": {
      "3178": true
    },
    "GUARDAMONTE": {
      "3179": true
    },
    "FEDERAL": {
      "3180": true
    },
    "MOREIRA": {
      "3181": true
    },
    "LOS CONQUISTADORES": {
      "3183": true
    },
    "SAN GUSTAVO": {
      "3184": true,
      "3191": true
    },
    "SAN JOSE DE FELICIANO": {
      "3187": true
    },
    "VILLA PERPER": {
      "3188": true
    },
    "LA PAZ": {
      "3190": true
    },
    "SANTA ELENA": {
      "3192": true
    },
    "CONCORDIA": {
      "3200": true,
      "3202": true,
      "3205": true,
      "3207": true
    },
    "PUERTO YERUA": {
      "3201": true
    },
    "BENITO LEGEREN": {
      "3203": true
    },
    "COLONIA LA GLORIA": {
      "3204": true
    },
    "FEDERACION": {
      "3206": true
    },
    "SANTA ANA": {
      "3208": true
    },
    "LA CRIOLLA": {
      "3212": true,
      "3217": true
    },
    "YUQUERI": {
      "3214": true
    },
    "LOS CHARRUAS": {
      "3215": true
    },
    "GENERAL CAMPOS": {
      "3216": true
    },
    "SAN SALVADOR": {
      "3218": true
    },
    "CHAJARI": {
      "3228": true
    },
    "VILLA DEL ROSARIO": {
      "3229": true
    },
    "PARADA PUCHETA": {
      "3235": true
    },
    "TAPEBICUA": {
      "3236": true
    },
    "VILLAGUAY": {
      "3240": true
    },
    "LAGUNA LARGA": {
      "3241": true
    },
    "VILLAGUAY ESTE": {
      "3244": true
    },
    "PUEBLO DOMINGUEZ": {
      "3246": true
    },
    "VILLA SAN MARCIAL": {
      "3248": true
    },
    "SANTA ANITA": {
      "3249": true
    },
    "VILLA ERRECABORDE": {
      "3250": true
    },
    "VILLA CLARA": {
      "3252": true
    },
    "JUBILEO": {
      "3254": true
    },
    "CONCEPCION DEL URUGUAY": {
      "3260": true,
      "3264": true
    },
    "COLONIA ELIA": {
      "3261": true
    },
    "CASEROS": {
      "3262": true
    },
    "PRONUNCIAMIENTO": {
      "3263": true
    },
    "VILLA ELISA": {
      "3265": true
    },
    "COLONIA VAZQUEZ": {
      "3267": true
    },
    "COLONIA E.GOUCHON": {
      "3269": true
    },
    "COLONIA HOCKER": {
      "3270": true
    },
    "LA CLARITA": {
      "3271": true
    },
    "HERRERA": {
      "3272": true
    },
    "COLONIA HUGHES": {
      "3275": true
    },
    "COLON": {
      "3280": true
    },
    "LIEBIG": {
      "3281": true,
      "3282": true
    },
    "SAN JOSE": {
      "3283": true
    },
    "EL BRILLANTE": {
      "3284": true
    },
    "BERDUC": {
      "3285": true
    },
    "PUEBLO COLORADO": {
      "3286": true
    },
    "UBAJAY": {
      "3287": true
    }
  },
  "CORDOBA": {
    "CRUZ ALTA": {
      "2189": true
    },
    "COLONIA ALPINA": {
      "2341": true
    },
    "SUARDI": {
      "2349": true
    },
    "SAN FRANCISCO": {
      "2400": true
    },
    "COLONIA CASTELAR": {
      "2401": true
    },
    "LUXARDO": {
      "2411": true
    },
    "FREYRE": {
      "2413": true
    },
    "COLONIA VALTELINA": {
      "2414": true
    },
    "PORTEÑA": {
      "2415": true
    },
    "LA PAQUITA": {
      "2416": true
    },
    "Altos de Chipion": {
      "2417": true
    },
    "SEEBER": {
      "2418": true
    },
    "BRINKMANN": {
      "2419": true
    },
    "COLONIA VIGNAUD": {
      "2420": true
    },
    "MORTEROS": {
      "2421": true
    },
    "QUEBRACHO HERRADO": {
      "2422": true
    },
    "MONTE REDONDO": {
      "2423": true
    },
    "DEVOTO": {
      "2424": true
    },
    "LA FRANCIA": {
      "2425": true
    },
    "COLONIA SAN BARTOLOME": {
      "2426": true
    },
    "EL FUERTECITO": {
      "2428": true
    },
    "LA TORDILLA NORTE": {
      "2429": true
    },
    "SAN PEDRO": {
      "2430": true
    },
    "EL TIO": {
      "2432": true
    },
    "VILLA CONCEPCION DEL TIO": {
      "2433": true
    },
    "ARROYITO": {
      "2434": true
    },
    "LA TORDILLA": {
      "2435": true
    },
    "TRANSITO": {
      "2436": true
    },
    "SAIRA": {
      "2525": true
    },
    "BELL VILLE": {
      "2550": true
    },
    "LOS PATOS": {
      "2551": true
    },
    "JUSTINIANO POSSE": {
      "2553": true
    },
    "ORDOÑEZ": {
      "2555": true
    },
    "IDIAZABAL": {
      "2557": true
    },
    "CINTRA": {
      "2559": true
    },
    "SAN ANTONIO DE LITIN": {
      "2560": true
    },
    "CHILIBROSTE": {
      "2561": true
    },
    "NOETINGER": {
      "2563": true
    },
    "SAN MARCOS SUD": {
      "2566": true
    },
    "MORRISON": {
      "2568": true
    },
    "BALLESTEROS": {
      "2572": true
    },
    "BALLESTEROS SUD": {
      "2573": true
    },
    "MARCOS JUAREZ": {
      "2580": true
    },
    "LOS SURGENTES": {
      "2581": true
    },
    "GENERAL BALDISSERA": {
      "2583": true
    },
    "CAMILO ALDAO": {
      "2585": true,
      "2586": true
    },
    "INRIVILLE": {
      "2587": true
    },
    "SALADILLO": {
      "2588": true
    },
    "MONTE BUEY": {
      "2589": true
    },
    "GENERAL ROCA": {
      "2592": true,
      "8338": true
    },
    "LEONES": {
      "2594": true
    },
    "KM 57": {
      "2619": true
    },
    "ARIAS": {
      "2624": true
    },
    "CAVANAGH": {
      "2625": true
    },
    "GUATIMOZIN": {
      "2627": true
    },
    "O'HIGGINS": {
      "2645": true
    },
    "COLONIA ITALIANA": {
      "2646": true
    },
    "CANALS": {
      "2650": true
    },
    "COLONIA BREMEN": {
      "2651": true
    },
    "COLONIA BISMARCK": {
      "2652": true
    },
    "Pueblo Italiano": {
      "2653": true
    },
    "WENCESLAO ESCALANTE": {
      "2655": true
    },
    "LABORDE": {
      "2657": true
    },
    "MONTE MAIZ": {
      "2659": true
    },
    "ISLA VERDE": {
      "2660": true,
      "2661": true
    },
    "ALEJO LEDESMA": {
      "2662": true,
      "2663": true
    },
    "BENJAMIN GOULD": {
      "2664": true
    },
    "LA CARLOTA": {
      "2670": true
    },
    "SANTA EUFEMIA": {
      "2671": true
    },
    "CHAZON": {
      "2675": true
    },
    "UCACHA": {
      "2677": true
    },
    "PASCANAS": {
      "2679": true
    },
    "ETRURIA": {
      "2681": true
    },
    "LOS CISNES": {
      "2684": true
    },
    "COLONIA MAIPU": {
      "2685": true
    },
    "ALEJANDRO": {
      "2686": true
    },
    "CORDOBA": {
      "5000": true,
      "5001": true,
      "5002": true,
      "5003": true,
      "5004": true,
      "5005": true,
      "5006": true,
      "5007": true,
      "5008": true,
      "5009": true,
      "5010": true,
      "5011": true,
      "5012": true,
      "5013": true,
      "5014": true,
      "5015": true,
      "5016": true,
      "5017": true,
      "5018": true,
      "5019": true,
      "5020": true,
      "5022": true,
      "5023": true,
      "5024": true,
      "5103": true,
      "5148": true
    },
    "VILLA ALLENDE": {
      "5021": true,
      "5105": true
    },
    "EXPEDICIàN CO": {
      "5100": true
    },
    "LOZADA": {
      "5101": true
    },
    "LA PUERTA": {
      "5102": true,
      "5137": true,
      "5138": true
    },
    "TIROLESA": {
      "5104": true
    },
    "VILLA CERRO AZUL": {
      "5106": true
    },
    "MENDIOLAZA": {
      "5107": true,
      "5108": true
    },
    "UNQUILLO": {
      "5109": true
    },
    "MALAGUEÑO": {
      "5110": true
    },
    "RIO CEBALLOS": {
      "5111": true
    },
    "SANTA ANA": {
      "5112": true
    },
    "SALSIPUEDES": {
      "5113": true
    },
    "EL MANZANO": {
      "5114": true
    },
    "LA GRANJA": {
      "5115": true
    },
    "ASCOCHINGA": {
      "5117": true
    },
    "MONTE RALO": {
      "5118": true
    },
    "CORONEL OLMEDO": {
      "5119": true
    },
    "LABOULAYE": {
      "5120": true,
      "6120": true
    },
    "DESPEÑADEROS": {
      "5121": true
    },
    "TOLEDO": {
      "5123": true
    },
    "SANTIAGO TEMPLE": {
      "5124": true
    },
    "MONTE CRISTO": {
      "5125": true
    },
    "MALVINAS ARGENTINAS": {
      "5126": true
    },
    "RIO PRIMERO": {
      "5127": true
    },
    "MI GRANJA": {
      "5128": true
    },
    "COMECHINGONES": {
      "5129": true
    },
    "PIQUILLIN": {
      "5130": true
    },
    "ESQUINA": {
      "5131": true
    },
    "SANTA ROSA DE RIO PRIMERO": {
      "5133": true
    },
    "VILLA FONTANA": {
      "5134": true
    },
    "LAS AVERIAS": {
      "5135": true
    },
    "DIEGO DE ROJAS": {
      "5136": true
    },
    "MARULL": {
      "5139": true
    },
    "BALNEARIA": {
      "5141": true
    },
    "LA CAUTIBA": {
      "5142": true
    },
    "MIRAMAR": {
      "5143": true
    },
    "RECREO VICTORIA": {
      "5144": true
    },
    "JUAREZ CELMAN": {
      "5145": true
    },
    "MAYU SUMAJ": {
      "5146": true
    },
    "ARGUELLO": {
      "5147": true
    },
    "VILLA WARCARDE": {
      "5149": true
    },
    "SALDAN": {
      "5150": true
    },
    "LA CALERA": {
      "5151": true
    },
    "VILLA CARLOS PAZ": {
      "5152": true,
      "5154": true
    },
    "VILLA COSTA AZUL": {
      "5153": true
    },
    "TANTI": {
      "5155": true
    },
    "VILLA SUIZA ARGENTINA": {
      "5156": true
    },
    "BIALET MASSE": {
      "5158": true
    },
    "VILLA RIO YCHO CRUZ": {
      "5159": true
    },
    "YCHO CRUZ SIERRAS": {
      "5161": true
    },
    "CASA GRANDE": {
      "5162": true
    },
    "SANTA MARIA DE PUNILLA": {
      "5164": true
    },
    "SANATORIO SANTA MARIA": {
      "5165": true
    },
    "COSQUIN": {
      "5166": true
    },
    "VILLA ANISACATE": {
      "5167": true
    },
    "VALLE HERMOSO": {
      "5168": true
    },
    "VILLA EL DESCANSO": {
      "5169": true
    },
    "VILLA LA BOLSA": {
      "5170": true
    },
    "LA FALDA": {
      "5172": true
    },
    "HUERTA GRANDE": {
      "5174": true
    },
    "CASA SERRANA": {
      "5175": true
    },
    "VILLA GIARDINO": {
      "5176": true
    },
    "LA CUMBRE": {
      "5178": true,
      "5180": true
    },
    "SAN ESTEBAN": {
      "5182": true,
      "5188": true
    },
    "CAPILLA DEL MONTE": {
      "5184": true
    },
    "ALTA GRACIA": {
      "5186": true
    },
    "SAN CLEMENTE": {
      "5187": true
    },
    "ANISACATE": {
      "5189": true
    },
    "SAN AGUSTIN": {
      "5191": true
    },
    "DIQUE LOS MOLINOS": {
      "5192": true
    },
    "VILLA GENERAL BELGRANO": {
      "5194": true
    },
    "SANTA ROSA DE CALAMUCHITA": {
      "5196": true
    },
    "YACANTO CALAMUCHITA": {
      "5197": true
    },
    "SAN IGNACIO": {
      "5199": true
    },
    "DEAN FUNES": {
      "5200": true
    },
    "COPACABANA": {
      "5201": true
    },
    "TULUMBA": {
      "5203": true
    },
    "EL CERRITO": {
      "5205": true
    },
    "LA TOTORILLA": {
      "5209": true
    },
    "LA AGUADA": {
      "5211": true
    },
    "SARMIENTO": {
      "5212": true
    },
    "QUILINO": {
      "5214": true
    },
    "VILLA QUILINO": {
      "5215": true
    },
    "TOTORALEJOS": {
      "5216": true
    },
    "CHUÑA": {
      "5218": true
    },
    "JESUS MARIA": {
      "5220": true
    },
    "SINSACATE": {
      "5221": true
    },
    "COLONIA CAROYA": {
      "5223": true
    },
    "OBISPO TREJO": {
      "5225": true
    },
    "LA POSTA": {
      "5227": true
    },
    "CAÑADA DE LUQUE": {
      "5229": true
    },
    "CAPILLA DE SITON": {
      "5231": true
    },
    "TAJAMARES": {
      "5233": true
    },
    "CANDELARIA NORTE": {
      "5235": true
    },
    "VILLA DEL TOTORAL": {
      "5236": true
    },
    "LAS PEÑAS": {
      "5238": true
    },
    "SIMBOLAR": {
      "5242": true
    },
    "AGUA DEL TALA": {
      "5243": true
    },
    "SAN JOSE DE LA DORMIDA": {
      "5244": true
    },
    "CAMINIAGA": {
      "5245": true
    },
    "CHURQUI": {
      "5246": true
    },
    "VILLA MARIA DE RIO SECO": {
      "5248": true
    },
    "LOS HOYOS": {
      "5249": true
    },
    "SOL DE JULIO": {
      "5255": true
    },
    "SERREZUELA": {
      "5270": true
    },
    "PUESTO DE VERA": {
      "5271": true
    },
    "LOS AGUIRRES": {
      "5278": true
    },
    "CRUZ DEL EJE": {
      "5280": true
    },
    "GUANACO MUERTO": {
      "5281": true
    },
    "SAN MARCOS SIERRA": {
      "5282": true
    },
    "LA LAGUNA": {
      "5283": true,
      "5901": true
    },
    "VILLA DE SOTO": {
      "5284": true
    },
    "BAÑADO DE SOTO": {
      "5285": true
    },
    "TUCLAME": {
      "5286": true
    },
    "CAPILLA LA CANDELARIA": {
      "5287": true
    },
    "CIENAGA DEL CORO": {
      "5289": true
    },
    "SAN CARLOS MINAS": {
      "5291": true
    },
    "OJO DE AGUA": {
      "5293": true
    },
    "SALSACATE": {
      "5295": true
    },
    "TALA CAÑADA": {
      "5297": true
    },
    "LA PALMA": {
      "5299": true
    },
    "LA BOLSA": {
      "5689": true
    },
    "RIO CUARTO": {
      "5800": true,
      "5802": true,
      "5804": true,
      "5806": true,
      "5808": true
    },
    "EL BAÑADO RIO CUARTO": {
      "5801": true
    },
    "REDUCCION": {
      "5803": true
    },
    "LAS HIGUERAS": {
      "5805": true
    },
    "CHARRAS": {
      "5807": true,
      "5814": true
    },
    "GENERAL CABRERA": {
      "5809": true
    },
    "CORONEL BAIGORRIA": {
      "5811": true
    },
    "ALCIRA": {
      "5813": true
    },
    "ELENA": {
      "5815": true
    },
    "BERROTARAN": {
      "5817": true
    },
    "LA CALERA CALAMUCHIT": {
      "5819": true
    },
    "RIO DE LOS SAUCES": {
      "5821": true
    },
    "CHUCUL": {
      "5822": true
    },
    "LOS CONDORES": {
      "5823": true
    },
    "OLAETA": {
      "5824": true
    },
    "HOLMBERG": {
      "5825": true
    },
    "LAS VERTIENTES": {
      "5827": true
    },
    "SAMPACHO": {
      "5829": true
    },
    "ESTACION ACHIRAS": {
      "5831": true
    },
    "MONTE DE LOS GAUCHOS": {
      "5832": true
    },
    "ACHIRAS": {
      "5833": true
    },
    "SUCO": {
      "5837": true
    },
    "MALENA": {
      "5838": true
    },
    "L JAGUELES": {
      "5839": true
    },
    "SAN BASILIO": {
      "5841": true
    },
    "ADELIA MARIA": {
      "5843": true
    },
    "BULNES": {
      "5845": true
    },
    "CORONEL MOLDES": {
      "5847": true
    },
    "SAN AMBROSIO": {
      "5848": true
    },
    "RIO TERCERO": {
      "5850": true
    },
    "COLONIA SANTA CATALINA": {
      "5851": true
    },
    "CORRALITO": {
      "5853": true
    },
    "ALMAFUERTE": {
      "5854": true
    },
    "EMBALSE": {
      "5856": true,
      "5858": true
    },
    "VILLA SEGUNDA": {
      "5857": true
    },
    "LA CRUZ": {
      "5859": true
    },
    "VILLA DEL DIQUE": {
      "5862": true
    },
    "VILLA RUMIPAL": {
      "5864": true
    },
    "SAN JOSE": {
      "5865": true
    },
    "VILLA DOLORES": {
      "5870": true
    },
    "PIEDRA PINTADA": {
      "5871": true
    },
    "CONLARA": {
      "5873": true
    },
    "LA POBLACION": {
      "5875": true
    },
    "YACANTO": {
      "5877": true
    },
    "LA PAZ": {
      "5879": true
    },
    "VILLA LAS ROSAS": {
      "5885": true
    },
    "NONO": {
      "5887": true
    },
    "MINA CLAVERO": {
      "5889": true
    },
    "VILLA CURA BROCHERO": {
      "5891": true
    },
    "ALTO GRANDE": {
      "5893": true
    },
    "VILLA MARIA": {
      "5900": true,
      "5918": true
    },
    "VILLA NUEVA": {
      "5903": true
    },
    "ANA ZUMARAN": {
      "5905": true
    },
    "ALTO ALEGRE": {
      "5907": true
    },
    "LAS MOJARRAS": {
      "5909": true
    },
    "COLONIA SILVIO PELLICO": {
      "5910": true
    },
    "LA PLAYOSA": {
      "5911": true
    },
    "POZO DEL MOLLE": {
      "5913": true
    },
    "CARRILOBO": {
      "5915": true
    },
    "ARROYO CABRAL": {
      "5917": true
    },
    "LUCA": {
      "5919": true
    },
    "LAS PERDICES": {
      "5921": true
    },
    "GENERAL DEHEZA": {
      "5923": true
    },
    "AUSONIA": {
      "5924": true
    },
    "PASCO": {
      "5925": true,
      "5953": true
    },
    "TICINO": {
      "5927": true,
      "5966": true
    },
    "HERNANDO": {
      "5929": true,
      "5968": true
    },
    "PAMPAYASTA SUD": {
      "5931": true
    },
    "TANCACHA": {
      "5933": true
    },
    "VILLA ASCASUBI": {
      "5935": true
    },
    "TIO PUJIO": {
      "5936": true
    },
    "LAS VARILLAS": {
      "5940": true,
      "5992": true
    },
    "LAS VARAS": {
      "5941": true
    },
    "SATUR M LASPIUR": {
      "5943": true
    },
    "SACANTA": {
      "5945": true
    },
    "EL ARAÑADO": {
      "5947": true
    },
    "ALICIA": {
      "5949": true
    },
    "EL FORTIN": {
      "5951": true
    },
    "LA PALESTINA": {
      "5957": true
    },
    "RIO SEGUNDO": {
      "5960": true
    },
    "COSTA SACATE": {
      "5961": true
    },
    "VILLA DEL ROSARIO": {
      "5963": true
    },
    "CALCHIN OESTE": {
      "5964": true,
      "5965": true
    },
    "LUQUE": {
      "5967": true
    },
    "CALCHIN": {
      "5969": true
    },
    "MATORRALES": {
      "5970": true
    },
    "COLAZO": {
      "5971": true,
      "5981": true
    },
    "PILAR": {
      "5972": true
    },
    "PAMPAYASTA NORTE": {
      "5973": true
    },
    "LAGUNA LARGA": {
      "5974": true
    },
    "PAMPAYASTA SUR": {
      "5975": true
    },
    "OLIVA": {
      "5980": true
    },
    "GENERAL FOTHERINGHAM": {
      "5982": true
    },
    "JAMES CRAIK": {
      "5984": true
    },
    "ONCATIVO": {
      "5986": true
    },
    "COLONIA ALMADA": {
      "5987": true
    },
    "MANFREDI": {
      "5988": true
    },
    "EL RASTREADOR": {
      "6121": true
    },
    "MELO": {
      "6123": true
    },
    "SERRANO": {
      "6125": true
    },
    "VILLA ROSSI": {
      "6126": true
    },
    "JOVITA": {
      "6127": true
    },
    "ROSSI": {
      "6128": true
    },
    "GENERAL LEVALLE": {
      "6132": true
    },
    "RIO BAMBA": {
      "6134": true
    },
    "VICUÑA MACKENNA": {
      "6140": true
    },
    "TOSQUITA": {
      "6141": true
    },
    "LA CAUTIVA": {
      "6142": true
    },
    "WASHINGTON": {
      "6144": true
    },
    "VILLA HUIDOBRO": {
      "6175": true,
      "6275": true
    },
    "HIPOLITO BOUCHARD": {
      "6225": true
    },
    "ONAGOITY": {
      "6227": true
    },
    "HUINCA RENANCO": {
      "6270": true
    },
    "NICOLAS BRUZONE": {
      "6271": true
    },
    "MATTALDI": {
      "6272": true
    },
    "VILLA VALERIA": {
      "6273": true,
      "6373": true
    },
    "BATAVIA": {
      "6279": true
    },
    "CAÑADON DE LOS MOGOTES": {
      "8184": true
    },
    "POCHO": {
      "5294": true
    },
    "PINCEN": {
      "6274": true
    },
    "ITALO": {
      "6278": true
    }
  },
  "SANTIAGO DEL ESTERO": {
    "SELVA": {
      "2354": true
    },
    "MALBRAN": {
      "2355": true
    },
    "PINTO": {
      "2356": true
    },
    "VILLA UNION": {
      "2357": true
    },
    "GUARDIA ESCOLTA": {
      "3062": true
    },
    "FORTIN INCA": {
      "3063": true
    },
    "BANDERA": {
      "3064": true
    },
    "LAS TEJAS": {
      "3165": true
    },
    "ROVERSI": {
      "3736": true
    },
    "QUIMILI": {
      "3740": true
    },
    "EL COLORADO": {
      "3741": true
    },
    "TINTINA": {
      "3743": true
    },
    "QUILUMPA": {
      "3745": true
    },
    "CAMPO GALLO": {
      "3747": true
    },
    "MONTE RICO": {
      "3749": true
    },
    "VILELAS": {
      "3752": true,
      "3753": true
    },
    "AÑATUYA": {
      "3760": true
    },
    "EL MALACARA": {
      "3761": true
    },
    "LOS JURIES": {
      "3763": true
    },
    "LA NENA": {
      "3765": true
    },
    "TACANITAS": {
      "3766": true
    },
    "LA MADRID": {
      "4176": true
    },
    "ESTACION ARAOZ": {
      "4177": true
    },
    "POZO HONDO": {
      "4184": true
    },
    "LAS CEJAS": {
      "4186": true
    },
    "BOBADAL": {
      "4187": true
    },
    "GOBERNADOR PIEDRABUENA": {
      "4188": true
    },
    "RAPELLI": {
      "4189": true
    },
    "NUEVA ESPERANZA": {
      "4197": true
    },
    "SGO DEL ESTERO": {
      "4200": true,
      "4204": true
    },
    "LOS QUIROGA": {
      "4201": true
    },
    "BARRIO HUACO HONDO": {
      "4202": true
    },
    "VIZCACHERAL": {
      "4203": true
    },
    "LAPRIDA": {
      "4205": true
    },
    "ZANJON": {
      "4206": true
    },
    "NUEVA FRANCIA": {
      "4207": true
    },
    "LORETO": {
      "4208": true
    },
    "GUANACO SOMBRIANA": {
      "4212": true
    },
    "TERMAS DE RIO HONDO": {
      "4220": true
    },
    "LA DONOSA": {
      "4221": true
    },
    "VINARA": {
      "4223": true
    },
    "BARRIALITO": {
      "4225": true
    },
    "VILLA RIO HONDO": {
      "4226": true
    },
    "LA REPRESA": {
      "4233": true
    },
    "SAN PEDRO": {
      "4238": true
    },
    "EL VEINTICINCO DE MAYO": {
      "4283": true
    },
    "LA BANDA": {
      "4300": true
    },
    "SANTO DOMINGO": {
      "4301": true
    },
    "EL AIBE": {
      "4302": true
    },
    "VILMER": {
      "4303": true
    },
    "GRAMILLA": {
      "4304": true
    },
    "EL CHARCO": {
      "4306": true
    },
    "BELTRAN": {
      "4308": true
    },
    "INGENIERO FORRES": {
      "4312": true
    },
    "ROBLES": {
      "4313": true
    },
    "ESTACION ATAMISQUI": {
      "4315": true
    },
    "VILLA ATAMISQUI": {
      "4317": true
    },
    "HUAJIA": {
      "4318": true
    },
    "CHILCA JULIANA": {
      "4319": true
    },
    "SAN ROQUE": {
      "4320": true
    },
    "TACO ISLA": {
      "4321": true
    },
    "FERNANDEZ": {
      "4322": true
    },
    "TABOADA ESTACION": {
      "4324": true
    },
    "LUGONES": {
      "4326": true
    },
    "HERRERA": {
      "4328": true
    },
    "COLONIA DORA": {
      "4332": true
    },
    "ICAÑO": {
      "4334": true
    },
    "REAL SAYANA": {
      "4335": true
    },
    "ABRA GRANDE": {
      "4336": true
    },
    "CLODOMIRA": {
      "4338": true
    },
    "LAS DELICIAS": {
      "4339": true
    },
    "SIMBOLAR": {
      "4340": true
    },
    "SUNCHO CORRAL": {
      "4350": true
    },
    "LAS TINAJAS": {
      "4351": true
    },
    "25 DE MAYO": {
      "4352": true
    },
    "LA INVERNADA": {
      "4353": true
    },
    "LA CAÑADA": {
      "4354": true
    },
    "TIUN PUNCO": {
      "4356": true
    },
    "PALPALA": {
      "4613": true
    },
    "OJO DE AGUA": {
      "5250": true
    },
    "LOMITAS BLANCAS": {
      "5251": true
    },
    "SUMAMPA": {
      "5253": true
    },
    "RAMIREZ DE VELAZCO": {
      "5257": true
    },
    "NEGRA MUERTA": {
      "5258": true
    },
    "LA FIRMEZA": {
      "5714": true
    }
  },
  "CATAMARCA": {
    "MONTE LEÑA": {
      "2564": true
    },
    "EL CRUCE": {
      "4138": true
    },
    "SANTA MARIA": {
      "4139": true
    },
    "FUERTE QUEMADO": {
      "4141": true
    },
    "FRIAS SDE": {
      "4230": true
    },
    "LAS PALMITAS": {
      "4231": true
    },
    "TAPSO": {
      "4234": true
    },
    "LAS CAÑAS": {
      "4235": true
    },
    "LAS PEÑAS": {
      "4237": true
    },
    "SAN FERNANDO DEL VALLE DE CATAMARCA": {
      "4700": true,
      "4702": true,
      "4703": true,
      "4704": true
    },
    "TACO": {
      "4701": true
    },
    "SUMALAO": {
      "4705": true,
      "4714": true
    },
    "POZO DEL MISTOL": {
      "4706": true
    },
    "TRES PUENTES": {
      "4707": true
    },
    "SAN ANTONIO FRAY M ESQUIU": {
      "4708": true
    },
    "ESQUIU": {
      "4709": true,
      "5261": true
    },
    "EL HUECO": {
      "4710": true
    },
    "COLPES": {
      "4711": true,
      "5319": true
    },
    "LA CARRERA": {
      "4712": true
    },
    "VILLA LAS PIRQUITAS": {
      "4713": true
    },
    "EL RODEO": {
      "4715": true
    },
    "PORTEZUELO": {
      "4716": true
    },
    "LA TERCENA": {
      "4717": true
    },
    "LA MERCED": {
      "4718": true
    },
    "BALCOSNA": {
      "4719": true
    },
    "BAÑADO DE OVANTA": {
      "4721": true
    },
    "LA VIÑA": {
      "4722": true
    },
    "ALIJILAN": {
      "4723": true
    },
    "MIRAFLORES": {
      "4724": true
    },
    "COLONIA DEL VALLE": {
      "4725": true
    },
    "HUILLAPIMA": {
      "4726": true
    },
    "CHUMBICHA": {
      "4728": true
    },
    "POLCOS": {
      "4730": true
    },
    "LA FALDA DE SAN ANTONIO": {
      "4731": true
    },
    "EL BAÑADO": {
      "4732": true
    },
    "ANDALGALA": {
      "4740": true
    },
    "VILLA VIL": {
      "4741": true
    },
    "CHAQUIAGO": {
      "4742": true
    },
    "EL ALAMITO": {
      "4743": true
    },
    "LA PUERTA DE SAN JOSE": {
      "4748": true
    },
    "BELEN": {
      "4750": true
    },
    "HUALFIN": {
      "4751": true
    },
    "LONDRES": {
      "4753": true
    },
    "EL EJE": {
      "4754": true
    },
    "TERMAS VILLA VIL": {
      "4755": true
    },
    "RECREO": {
      "5260": true
    },
    "LA GUARDIA": {
      "5262": true,
      "5263": true
    },
    "SAN ANTONIO DE LA PAZ": {
      "5264": true
    },
    "BAVIANO": {
      "5265": true
    },
    "QUIROS": {
      "5266": true
    },
    "VILLA MAZAN": {
      "5314": true
    },
    "POMAN": {
      "5315": true
    },
    "RINCON": {
      "5317": true
    },
    "SAUJIL": {
      "5321": true
    },
    "EL PUEBLITO": {
      "5331": true
    },
    "SALADO": {
      "5332": true
    },
    "COPACABANA": {
      "5333": true
    },
    "TINOGASTA": {
      "5340": true
    },
    "EL PUESTO": {
      "5341": true
    },
    "TATON": {
      "5342": true
    },
    "SANTA ROSA": {
      "5343": true
    },
    "VILLA SAN ROQUE": {
      "5344": true
    },
    "FIAMBALA": {
      "5345": true
    },
    "LAVALLE": {
      "5347": true
    }
  },
  "CORRIENTES": {
    "SAN JAIME DE LA FRONTERA": {
      "3085": true,
      "3185": true
    },
    "GUAYQUIRARO": {
      "3194": true
    },
    "ESQUINA": {
      "3196": true
    },
    "LIBERTADOR": {
      "3197": true
    },
    "PARAJE EL CARMEN": {
      "3199": true
    },
    "MONTE CASEROS": {
      "3220": true
    },
    "PARADA LABOUGLE": {
      "3222": true
    },
    "COLONIA LIBERTAD": {
      "3224": true
    },
    "MOCORETA": {
      "3226": true
    },
    "PASO DE LOS LIBRES": {
      "3230": true
    },
    "YAPEYU": {
      "3231": true
    },
    "CABRED": {
      "3232": true
    },
    "BOMPLAND": {
      "3234": true
    },
    "ITUZAINGO": {
      "3302": true
    },
    "SAN JOSE": {
      "3306": true
    },
    "SAN CARLOS": {
      "3307": true,
      "3345": true
    },
    "SANTO TOME": {
      "3340": true,
      "3341": true
    },
    "GOBERNADOR VIRASORO": {
      "3342": true,
      "3343": true
    },
    "ALVEAR": {
      "3344": true
    },
    "LA CRUZ": {
      "3346": true
    },
    "AZARA": {
      "3351": true
    },
    "CORRIENTES": {
      "3400": true,
      "3401": true,
      "3402": true,
      "3404": true,
      "3406": true,
      "3408": true,
      "3410": true
    },
    "CAVIA CUE": {
      "3403": true
    },
    "LOMAS DE AGUIRRE": {
      "3405": true
    },
    "CAPILLITA": {
      "3407": true
    },
    "PASO DE LA PATRIA": {
      "3409": true
    },
    "LAGUNA BRAVA": {
      "3411": true
    },
    "ENSENADA GRANDE": {
      "3412": true
    },
    "ITATI": {
      "3414": true
    },
    "RIACHUELO": {
      "3416": true
    },
    "EMPEDRADO": {
      "3418": true
    },
    "SALADAS": {
      "3420": true
    },
    "SANTA ROSA": {
      "3421": true,
      "3424": true
    },
    "CONCEPCION": {
      "3423": true
    },
    "PAGO DE LOS DESEOS": {
      "3425": true
    },
    "TATACUA": {
      "3426": true
    },
    "MANANTIALES": {
      "3427": true
    },
    "ESTACION SALADAS": {
      "3428": true
    },
    "BELLA VISTA": {
      "3432": true
    },
    "CARRIZAL NORTE": {
      "3433": true
    },
    "ABALO": {
      "3436": true
    },
    "SANTA LUCIA": {
      "3440": true
    },
    "CRUZ DE LOS MILAGROS": {
      "3441": true
    },
    "BARRIO VILLA CORDOBA": {
      "3442": true
    },
    "LAVALLE": {
      "3443": true
    },
    "GOBERNADOR JUAN E MARTINEZ": {
      "3444": true
    },
    "GOBERNADOR MARTINEZ": {
      "3445": true
    },
    "MANUEL FLORENCIO MANTILLA": {
      "3446": true
    },
    "ARROYITO": {
      "3448": true
    },
    "COLONIA PANDO": {
      "3449": true
    },
    "GOYA": {
      "3450": true
    },
    "COLONIA DEL CARMEN": {
      "3451": true
    },
    "PEDRO R FERNANDEZ": {
      "3452": true
    },
    "ISABEL VICTORIA - IFRAN": {
      "3453": true
    },
    "BUENA VISTA": {
      "3454": true
    },
    "CURUZU CUATIA": {
      "3460": true
    },
    "PERUGORRIA": {
      "3461": true
    },
    "SAUCE": {
      "3463": true
    },
    "CAPITAN JOAQUIN": {
      "3465": true
    },
    "BAIBIENE": {
      "3466": true
    },
    "MERCEDES": {
      "3470": true
    },
    "ALFONSO LOMA": {
      "3471": true
    },
    "FELIPE YOFRE": {
      "3472": true
    },
    "COLONIA CARLOS PELLEGRINI": {
      "3473": true
    },
    "CHAVARRIA": {
      "3474": true
    },
    "SOLARI": {
      "3476": true
    },
    "ITA IBATE": {
      "3480": true
    },
    "BERON DE ASTRADA": {
      "3481": true
    },
    "LORETO": {
      "3483": true
    },
    "SAN MIGUEL": {
      "3485": true
    },
    "VILLA OLIVARI": {
      "3486": true
    },
    "PUESTO DE ISLA": {
      "3487": true
    },
    "GARCETE CUE": {
      "3641": true
    }
  },
  "MISIONES": {
    "POSADAS": {
      "3300": true,
      "3301": true,
      "3303": true,
      "3305": true,
      "3329": true,
      "3330": true
    },
    "GARUPA": {
      "3304": true
    },
    "CANDELARIA": {
      "3308": true
    },
    "CERRO CORA": {
      "3309": true,
      "3319": true
    },
    "MIGUEL LANUS": {
      "3310": true
    },
    "OLEGARIO V.ANDRADE": {
      "3311": true
    },
    "BARRIO DON SANTIAGO": {
      "3312": true
    },
    "CERRO AZUL": {
      "3313": true
    },
    "LEANDRO N ALEM": {
      "3315": true
    },
    "SANTA ANA": {
      "3316": true
    },
    "BONPLAND": {
      "3317": true
    },
    "COLONIA MARTIRES": {
      "3318": true
    },
    "PUERTO ESPAÑA": {
      "3320": true
    },
    "COLONIA POLANA": {
      "3321": true,
      "3328": true
    },
    "SAN IGNACIO": {
      "3322": true
    },
    "COLONIA DOMINGO SAVIO": {
      "3323": true
    },
    "GOBERNADOR ROCA": {
      "3324": true
    },
    "MOJON GRANDE": {
      "3325": true
    },
    "SANTO PIPO": {
      "3326": true
    },
    "CORPUS": {
      "3327": true
    },
    "MBOPICUA": {
      "3331": true
    },
    "CAPIOVY": {
      "3332": true
    },
    "PUERTO LEONI": {
      "3333": true
    },
    "GARUHAPE": {
      "3334": true,
      "3396": true
    },
    "HIPOLITO YRIGOYEN": {
      "3335": true
    },
    "COLONIA ALMAFUERTE": {
      "3336": true
    },
    "FRIGO": {
      "3337": true
    },
    "MARIANO MORENO": {
      "3338": true
    },
    "SALTO ENCANTADO": {
      "3339": true
    },
    "APOSTOLES": {
      "3350": true
    },
    "SAN PEDRO": {
      "3352": true
    },
    "TRES CAPONES": {
      "3353": true,
      "3354": true
    },
    "CONCEPCION DE LA SIERRA": {
      "3355": true
    },
    "SAN VICENTE": {
      "3356": true
    },
    "SAN JAVIER": {
      "3357": true
    },
    "PLAYADITO": {
      "3358": true
    },
    "ESTACION APOSTOLES": {
      "3359": true
    },
    "OBERA": {
      "3360": true,
      "3365": true
    },
    "CAMPO RAMON": {
      "3361": true,
      "3367": true
    },
    "CAMPO GRANDE": {
      "3362": true
    },
    "ALBA POSSE": {
      "3363": true
    },
    "ARISTOBULO DEL VALLE": {
      "3364": true
    },
    "SAN ANTONIO": {
      "3366": true,
      "3383": true
    },
    "VILLA BONITA": {
      "3368": true
    },
    "GUARANI": {
      "3369": true
    },
    "PUERTO IGUAZU": {
      "3370": true
    },
    "CABUREI": {
      "3371": true
    },
    "CATARATAS DEL IGUAZU": {
      "3372": true
    },
    "PANAMBI": {
      "3373": true
    },
    "LIBERTAD": {
      "3374": true
    },
    "CAMPO VIERA": {
      "3375": true
    },
    "WANDA": {
      "3376": true
    },
    "SANTA RITA": {
      "3377": true
    },
    "PUERTO ESPERANZA": {
      "3378": true
    },
    "25 DE MAYO": {
      "3379": true
    },
    "ELDORADO": {
      "3380": true
    },
    "PUERTO PIRAY": {
      "3381": true
    },
    "PUERTO LINARES": {
      "3382": true
    },
    "EL ALCAZAR": {
      "3384": true,
      "3390": true
    },
    "ALMIRANTE BROWN": {
      "3385": true
    },
    "COLONIA CARAGUATAY": {
      "3386": true
    },
    "SANTIAGO DE LINIERS": {
      "3387": true
    },
    "COLONIA VICTORIA": {
      "3388": true
    },
    "PUERTO PINARES": {
      "3389": true
    },
    "GARRUCHOS": {
      "3391": true
    },
    "COLONIA ALBERDI": {
      "3393": true
    }
  },
  "CHACO": {
    "RESISTENCIA": {
      "3500": true,
      "3501": true,
      "3502": true,
      "3504": true,
      "3506": true,
      "3508": true
    },
    "BARRANQUERAS": {
      "3503": true
    },
    "COLONIA BENITEZ": {
      "3505": true,
      "3510": true
    },
    "LA EDUVIGES": {
      "3507": true,
      "3648": true
    },
    "GENERAL JOSE DE SAN MARTIN": {
      "3509": true
    },
    "PRESIDENCIA ROCA": {
      "3511": true
    },
    "PUERTO VILELAS": {
      "3512": true
    },
    "COTE LAI": {
      "3513": true
    },
    "LA LEONESA": {
      "3514": true,
      "3518": true
    },
    "COLONIAS UNIDAS": {
      "3515": true,
      "3532": true
    },
    "LA PASTORIL": {
      "3517": true
    },
    "CABO ADRIANO AYALA": {
      "3519": true
    },
    "GENERAL VEDIA": {
      "3520": true,
      "3522": true
    },
    "PUERTO TIROL": {
      "3521": true,
      "3535": true
    },
    "LAS PALMAS": {
      "3523": true
    },
    "PUERTO BERMEJO": {
      "3524": true
    },
    "LA VERDE": {
      "3527": true
    },
    "MAKALLE": {
      "3528": true
    },
    "QUITILIPI": {
      "3530": true
    },
    "PAMPA DEL INDIO": {
      "3531": true
    },
    "LAS GARCITAS": {
      "3533": true
    },
    "MACHAGAY": {
      "3534": true
    },
    "PRESIDENCIA DE LA PLAZA": {
      "3536": true
    },
    "VILLA ANGELA": {
      "3540": true
    },
    "SANTA SYLVINA": {
      "3541": true,
      "3542": true
    },
    "SAMUHU": {
      "3543": true
    },
    "ENRIQUE URIEN": {
      "3544": true
    },
    "VILLA BERTHET": {
      "3545": true
    },
    "COMANDANTE FONTANA": {
      "3620": true
    },
    "LAGUNA YEMA": {
      "3634": true
    },
    "CENTRO FRONTERIZO CLORINDA": {
      "3642": true
    },
    "9 DE JULIO": {
      "3643": true
    },
    "GATO COLORADO": {
      "3647": true
    },
    "VILLA SARMIENTO": {
      "3657": true
    },
    "BARRIO JOSE DE SAN MARTIN": {
      "3698": true
    },
    "BARRIO SARMIENTO": {
      "3699": true
    },
    "PRESIDENCIA ROQUE SAENZ PEÑA": {
      "3700": true
    },
    "SAN BERNARDO": {
      "3701": true,
      "3726": true
    },
    "WICHI": {
      "3702": true
    },
    "FORTIN LAVALLE": {
      "3703": true
    },
    "EL SAUZALITO": {
      "3704": true
    },
    "JUAN JOSE CASTELLI": {
      "3705": true
    },
    "NAPENAY": {
      "3706": true
    },
    "PAMPA DEL INFIERNO": {
      "3708": true,
      "3721": true
    },
    "LOS FRENTONES": {
      "3712": true,
      "3715": true
    },
    "TACO POZO": {
      "3713": true,
      "3717": true
    },
    "URUTAU": {
      "3714": true
    },
    "CAMPO LARGO": {
      "3716": true
    },
    "CORZUELA": {
      "3718": true
    },
    "RIO MUERTO": {
      "3719": true
    },
    "LAS BREÑAS": {
      "3722": true,
      "3724": true
    },
    "LA CLOTILDE": {
      "3725": true
    },
    "TRES ESTACAS": {
      "3727": true
    },
    "PAMPA SOMMER": {
      "3728": true
    },
    "MESON DE FIERRO": {
      "3729": true
    },
    "CHARATA": {
      "3730": true
    },
    "SACHAYOJ": {
      "3731": true
    },
    "GRAL PINEDO": {
      "3732": true
    },
    "ITIN": {
      "3733": true
    },
    "GANCEDO": {
      "3734": true
    },
    "CHOROTIS": {
      "3735": true
    }
  },
  "FORMOSA": {
    "GRAL LUCIO V MANSILLA": {
      "3526": true
    },
    "VILLA ESCOLAR": {
      "3548": true
    },
    "FORMOSA": {
      "3600": true,
      "3616": true
    },
    "HERRADURA": {
      "3601": true
    },
    "VILLA DOS TRECE": {
      "3602": true
    },
    "EL COLORADO": {
      "3603": true
    },
    "MARIANO BOEDO": {
      "3604": true
    },
    "SAN FRANCISCO DE LAISHI": {
      "3605": true
    },
    "PIRANE": {
      "3606": true
    },
    "PALO SANTO": {
      "3608": true
    },
    "COLONIA CAMPO VILLAFAÑE": {
      "3609": true
    },
    "CLORINDA": {
      "3610": true
    },
    "PUERTO PILCOMAYO": {
      "3611": true,
      "3639": true
    },
    "SIETE PALMAS": {
      "3612": true
    },
    "LAGUNA BLANCA": {
      "3613": true
    },
    "MISION TACAAGLE": {
      "3614": true
    },
    "EL ESPINILLO": {
      "3615": true
    },
    "BUENA VISTA": {
      "3617": true
    },
    "SAN HILARIO": {
      "3618": true
    },
    "VILLA GRAL GUEMES": {
      "3621": true
    },
    "BRUCHARD": {
      "3622": true
    },
    "IBARRETA": {
      "3624": true
    },
    "DR E R.MEJIA CHIRIGUANOS": {
      "3625": true
    },
    "ESTANISLAO DEL CAMPO": {
      "3626": true
    },
    "SAN MARTIN II": {
      "3627": true
    },
    "POZO DEL TIGRE": {
      "3628": true
    },
    "LAS LOMITAS": {
      "3630": true
    },
    "GENERAL FRANCISCO BASILIANO BOSCH": {
      "3632": true
    },
    "INGENIERO JUAREZ": {
      "3636": true
    },
    "GENERAL MOSCONI": {
      "3637": true
    },
    "LAGUNA NAICK NECK": {
      "3640": true
    }
  },
  "TUCUMAN": {
    "SAN MIGUEL DE TUCUMAN": {
      "4000": true,
      "4001": true,
      "4002": true,
      "4178": true
    },
    "PACARA": {
      "4003": true
    },
    "VILLA CARMELA": {
      "4005": true,
      "4010": true
    },
    "SANTA MARIA": {
      "4011": true
    },
    "LOS SARMIENTOS": {
      "4065": true
    },
    "LOS POCITOS": {
      "4101": true,
      "4102": true
    },
    "TAFI VIEJO": {
      "4103": true
    },
    "EL MANANTIAL": {
      "4104": true
    },
    "MANANTIAL": {
      "4105": true,
      "4128": true
    },
    "YERBA BUENA": {
      "4107": true
    },
    "SAN JAVIER": {
      "4108": true
    },
    "BANDA DEL RIO SALI": {
      "4109": true
    },
    "CAMPO HERRERA": {
      "4110": true
    },
    "LASTENIA": {
      "4111": true,
      "4116": true
    },
    "EL BRACHO": {
      "4112": true
    },
    "LEALES": {
      "4113": true
    },
    "AGUA DULCE": {
      "4115": true
    },
    "DELFIN GALLO": {
      "4117": true
    },
    "VILLA FIAD": {
      "4118": true
    },
    "LA RAMADA DE ABAJO": {
      "4119": true
    },
    "EL CHAÑAR": {
      "4120": true
    },
    "VILLA BURRUYACU": {
      "4121": true
    },
    "TAPIA": {
      "4122": true
    },
    "TRANCAS": {
      "4124": true
    },
    "LOS ZAZOS": {
      "4125": true
    },
    "TAFI DEL VALLE": {
      "4127": true,
      "4137": true,
      "4140": true
    },
    "LA REDUCCION": {
      "4129": true,
      "4131": true
    },
    "MERCEDES": {
      "4130": true
    },
    "FAMAILLA": {
      "4132": true
    },
    "PADILLA": {
      "4133": true
    },
    "ACHERAL": {
      "4134": true
    },
    "INGENIO SANTA LUCIA": {
      "4135": true
    },
    "NUEVA BAVIERA": {
      "4136": true
    },
    "MONTEROS": {
      "4142": true
    },
    "INDEPENDENCIA": {
      "4143": true
    },
    "VILLA QUINTEROS": {
      "4144": true
    },
    "RIO SECO": {
      "4145": true
    },
    "CONCEPCION": {
      "4146": true
    },
    "ARCADIA": {
      "4147": true
    },
    "EL MOLINO": {
      "4149": true
    },
    "FUERTE QUEMADO": {
      "4150": true
    },
    "VILLA LA TRINIDAD": {
      "4151": true
    },
    "AGUILARES": {
      "4152": true
    },
    "ALTO VERDE": {
      "4153": true
    },
    "TOLOMBON": {
      "4154": true
    },
    "INGENIO SANTA ANA": {
      "4155": true
    },
    "SOLDADO MALDONADO": {
      "4156": true
    },
    "LA TIPA": {
      "4157": true
    },
    "ALBERDI": {
      "4158": true
    },
    "CAMPO BELLO": {
      "4159": true
    },
    "CAPITAN CACERES": {
      "4160": true
    },
    "DONATO ALVAREZ": {
      "4161": true
    },
    "LA COCHA": {
      "4162": true
    },
    "HUASA PAMPA": {
      "4163": true
    },
    "RUMI PUNCO": {
      "4164": true
    },
    "SARGENTO MOYA": {
      "4165": true
    },
    "MANUEL GARCIA": {
      "4166": true
    },
    "ALTO DE MEDINA": {
      "4167": true
    },
    "BELLA VISTA": {
      "4168": true
    },
    "SAN IGNACIO": {
      "4171": true
    },
    "SIMOCA": {
      "4172": true
    },
    "RIO COLORADO": {
      "4173": true
    },
    "LOS AGUIRRE": {
      "4174": true
    },
    "RANCHILLOS": {
      "4179": true
    },
    "GARMENDIA": {
      "4181": true
    },
    "LOS RALOS": {
      "4182": true
    },
    "TACO RALO": {
      "4242": true
    },
    "LA VIÑA": {
      "4424": true
    }
  },
  "SALTA": {
    "LA RAMADA": {
      "4123": true
    },
    "TALA": {
      "4126": true
    },
    "ROSARIO DE LA FRONTERA": {
      "4190": true
    },
    "EL NARANJO": {
      "4191": true
    },
    "LOS BAÑOS": {
      "4193": true
    },
    "7 DE ABRIL": {
      "4194": true
    },
    "SIETE DE ABRIL": {
      "4195": true
    },
    "ARENAL": {
      "4198": true
    },
    "MATARA": {
      "4357": true
    },
    "SALTA": {
      "4400": true,
      "4402": true,
      "4404": true,
      "4406": true,
      "4408": true,
      "4410": true,
      "4412": true,
      "4414": true
    },
    "SAN LORENZO": {
      "4401": true
    },
    "CERRILLOS": {
      "4403": true
    },
    "ROSARIO DE LERMA": {
      "4405": true
    },
    "CAMPO QUIJANO": {
      "4407": true
    },
    "EL ALISAL": {
      "4409": true
    },
    "SAN A DE LOS COBRES": {
      "4411": true
    },
    "CAIPE": {
      "4413": true
    },
    "PAYOGASTA": {
      "4415": true,
      "4418": true
    },
    "LA POMA": {
      "4416": true
    },
    "CACHI": {
      "4417": true
    },
    "SECLANTAS": {
      "4419": true
    },
    "MOLINOS": {
      "4420": true
    },
    "EL CARRIL": {
      "4421": true
    },
    "CHICOANA": {
      "4423": true
    },
    "GUACHIPAS": {
      "4425": true
    },
    "ANGASTACO": {
      "4426": true
    },
    "CAFAYATE": {
      "4427": true
    },
    "SAN CARLOS": {
      "4428": true
    },
    "ANIMANA": {
      "4429": true
    },
    "GENERAL GUEMES": {
      "4430": true
    },
    "CAMPO SANTO": {
      "4432": true
    },
    "LA SILLETA": {
      "4433": true
    },
    "PALOMITAS": {
      "4434": true
    },
    "METAN": {
      "4440": true
    },
    "METAN VIEJO": {
      "4441": true
    },
    "EL GALPON": {
      "4444": true
    },
    "EL TUÑAL": {
      "4446": true
    },
    "JOAQUIN V GONZALEZ": {
      "4448": true
    },
    "EL BORDO": {
      "4449": true
    },
    "LAS LAJITAS": {
      "4450": true
    },
    "CORONEL MOLLINEDO": {
      "4451": true
    },
    "GAONA": {
      "4452": true
    },
    "EL QUEBRACHAL": {
      "4453": true
    },
    "ORAN": {
      "4530": true
    },
    "LOS TOLDOS": {
      "4531": true
    },
    "HIPOLITO YRIGOYEN": {
      "4532": true
    },
    "EL TABACAL": {
      "4533": true
    },
    "PICHANAL": {
      "4534": true
    },
    "POZO CERCADO": {
      "4535": true
    },
    "LA ESTRELLA": {
      "4537": true
    },
    "SAUCELITO": {
      "4538": true
    },
    "EMBARCACION": {
      "4550": true
    },
    "GENERAL BALLIVIAN": {
      "4552": true
    },
    "PEDRO LOZANO": {
      "4554": true
    },
    "LOS BLANCOS": {
      "4555": true
    },
    "TARTAGAL": {
      "4560": true
    },
    "GENERAL ENRIQUE MOSCONI": {
      "4562": true
    },
    "CAMINERA SAN PEDRITO": {
      "4563": true
    },
    "PIQUIRENDA": {
      "4564": true
    },
    "AGUARAY": {
      "4566": true
    },
    "POCITOS": {
      "4568": true
    }
  },
  "JUJUY": {
    "AGUAS CALIENTES": {
      "4431": true,
      "4606": true
    },
    "SAN PEDRO": {
      "4500": true,
      "4502": true,
      "4609": true
    },
    "EL PIQUETE": {
      "4501": true
    },
    "LA ESPERANZA": {
      "4503": true
    },
    "EL QUEMADO": {
      "4504": true
    },
    "FRAILE PINTADO": {
      "4506": true
    },
    "PALMA SOLA": {
      "4510": true
    },
    "LEDESMA": {
      "4512": true
    },
    "PAMPICHUELA": {
      "4513": true
    },
    "CALILEGUA": {
      "4514": true
    },
    "CAIMANCITO": {
      "4516": true
    },
    "YUTO": {
      "4518": true
    },
    "LA MENDIETA": {
      "4522": true
    },
    "RAWSON": {
      "4523": true
    },
    "EL TALAR": {
      "4541": true
    },
    "URUNDEL": {
      "4542": true
    },
    "SANTA MARIA": {
      "4561": true
    },
    "SAN SALVADOR DE JUJUY": {
      "4600": true,
      "4602": true,
      "4604": true,
      "4607": true
    },
    "OCLOYAS": {
      "4601": true
    },
    "PERICO DEL CARMEN": {
      "4603": true,
      "4605": true
    },
    "MONTERRICO": {
      "4608": true
    },
    "PERICO": {
      "4610": true
    },
    "PALPALA": {
      "4612": true
    },
    "YALA": {
      "4616": true,
      "4617": true
    },
    "PURMAMARCA": {
      "4618": true,
      "4619": true
    },
    "MAIMARA": {
      "4622": true
    },
    "TILCARA": {
      "4624": true
    },
    "HUACALERA": {
      "4626": true
    },
    "ITURBE": {
      "4629": true,
      "4632": true
    },
    "HUMAHUACA": {
      "4630": true
    },
    "CASPALA": {
      "4631": true
    },
    "IRUYA": {
      "4633": true
    },
    "EL AGUILAR": {
      "4634": true
    },
    "HIPOLITO YRIGOYEN ESTACION ITURBE": {
      "4635": true
    },
    "TRES CRUCES": {
      "4636": true
    },
    "SAN FRANCISCO DE ALFARCITO": {
      "4639": true
    },
    "ABRA PAMPA": {
      "4640": true
    },
    "COCHINOCA": {
      "4641": true
    },
    "SUSQUES": {
      "4642": true
    },
    "CARAHUASI": {
      "4643": true
    },
    "PUESTO DEL MARQUEZ": {
      "4644": true
    },
    "RINCONADA": {
      "4645": true
    },
    "TOBA": {
      "4648": true
    },
    "BARRIOS": {
      "4649": true
    },
    "LA QUIACA": {
      "4650": true
    },
    "YAVI": {
      "4651": true
    },
    "SANTA VICTORIA": {
      "4652": true
    },
    "CIENEGUILLAS": {
      "4653": true
    },
    "SANTA CATALINA": {
      "4655": true
    },
    "ORATORIO": {
      "4656": true
    }
  },
  "SAN LUIS": {
    "SANTA CLARA": {
      "5157": true
    },
    "SAN LUIS": {
      "5700": true,
      "5702": true,
      "5710": true,
      "5780": true,
      "5886": true
    },
    "EL CHORRILLO": {
      "5701": true,
      "5723": true
    },
    "EL MILAGRO": {
      "5703": true
    },
    "POTRERO DE LOS FUNES": {
      "5704": true
    },
    "SAN FCO DEL MONTE DE ORO": {
      "5705": true
    },
    "BOTIJAS": {
      "5707": true
    },
    "LUJAN": {
      "5709": true
    },
    "QUINES": {
      "5711": true
    },
    "CANDELARIA": {
      "5713": true
    },
    "BALDE DEL ESCUDERO": {
      "5715": true
    },
    "VILLA DE LA QUEBRADA": {
      "5716": true
    },
    "SAN ROQUE": {
      "5718": true
    },
    "SAN GERONIMO": {
      "5719": true
    },
    "NOGOLI": {
      "5720": true
    },
    "ESTACION ZANJITAS": {
      "5721": true
    },
    "AUTO GRANDE": {
      "5722": true
    },
    "BALDE": {
      "5724": true
    },
    "CAROLINA": {
      "5725": true
    },
    "LA FLORIDA": {
      "5726": true
    },
    "LAVAISSE": {
      "5730": true
    },
    "JUAN JORBA": {
      "5731": true
    },
    "LA GAMA": {
      "5732": true
    },
    "VILLA REYNOLDS": {
      "5733": true
    },
    "LA RIBERA": {
      "5734": true
    },
    "JUAN LLERENA": {
      "5735": true
    },
    "FRAGA": {
      "5736": true
    },
    "JUSTO DARACT": {
      "5738": true
    },
    "AVIADOR ORIGONE": {
      "5741": true
    },
    "NUEVA ESCOCIA": {
      "5743": true
    },
    "LA TOMA": {
      "5750": true
    },
    "LA PETRA": {
      "5751": true
    },
    "LAS CHACRAS": {
      "5752": true,
      "5880": true
    },
    "PASO GRANDE": {
      "5753": true,
      "5761": true
    },
    "SAN MARTIN": {
      "5755": true
    },
    "SAN LORENZO": {
      "5757": true
    },
    "JUANA KOSLAY": {
      "5758": true
    },
    "NASCHEL": {
      "5759": true
    },
    "LA VERTIENTE": {
      "5760": true
    },
    "VILLA DE PRAGA": {
      "5762": true
    },
    "GENERAL URQUIZA": {
      "5763": true
    },
    "CONCARAN": {
      "5770": true
    },
    "PUERTA COLORADA": {
      "5771": true
    },
    "TILISARAO": {
      "5773": true
    },
    "SAN PABLO": {
      "5774": true
    },
    "MANANTIAL DE FLORES": {
      "5775": true
    },
    "SANTA ROSA DE CONLARA": {
      "5777": true
    },
    "CABEZA DE NOVILLO": {
      "5779": true
    },
    "VILLA DEL CARMEN": {
      "5835": true
    },
    "LOS CERRILLOS": {
      "5867": true
    },
    "LAFINUR": {
      "5872": true
    },
    "QUEBRACHO LADEADO": {
      "5874": true
    },
    "MERLO": {
      "5881": true
    },
    "VILLA LARCA": {
      "5882": true
    },
    "CARPINTERIA": {
      "5883": true,
      "5888": true
    },
    "LOS HORNILLOS": {
      "5884": true
    },
    "UNION": {
      "6216": true
    },
    "LA COLINA": {
      "6269": true
    },
    "BUENA ESPERANZA": {
      "6277": true
    },
    "ANCHORENA": {
      "6389": true
    }
  },
  "LA RIOJA": {
    "EL MEDANITO": {
      "5272": true
    },
    "MILAGRO": {
      "5274": true
    },
    "LOS AGUIRRES": {
      "5275": true
    },
    "CASTRO BARROS": {
      "5276": true
    },
    "CHAÑAR": {
      "5277": true
    },
    "LA RIOJA": {
      "5300": true,
      "5302": true,
      "5305": true
    },
    "ANILLACO": {
      "5301": true,
      "5330": true
    },
    "ANJULLON": {
      "5303": true
    },
    "TALAMUYUNA": {
      "5304": true
    },
    "BAZAN": {
      "5306": true
    },
    "PINCHAS": {
      "5307": true
    },
    "SAN MIGUEL": {
      "5308": true,
      "5364": true
    },
    "SAN PEDRO": {
      "5309": true
    },
    "AIMOGASTA": {
      "5310": true
    },
    "MACHIGASTA": {
      "5311": true
    },
    "ESTACION MAZAN": {
      "5313": true
    },
    "ALPASINCHE": {
      "5325": true
    },
    "SANTA VERA CRUZ": {
      "5326": true
    },
    "SALICAS - SAN BLAS": {
      "5327": true
    },
    "LOS MOLINOS": {
      "5328": true
    },
    "SCHAQUI": {
      "5329": true
    },
    "SAN JOSE DE TINOGASTA": {
      "5339": true
    },
    "VILLA UNION": {
      "5350": true
    },
    "BANDA FLORIDA": {
      "5351": true
    },
    "LOS PALACIOS": {
      "5352": true
    },
    "GUANDACOL": {
      "5353": true
    },
    "VILLA CASTELLI": {
      "5355": true
    },
    "AGUA BLANCA": {
      "5356": true
    },
    "VINCHINA": {
      "5357": true
    },
    "DISTRITO PUEBLO": {
      "5359": true,
      "5371": true
    },
    "CHILECITO": {
      "5360": true
    },
    "ANTINACO": {
      "5361": true,
      "5362": true
    },
    "ANGUINAN": {
      "5363": true
    },
    "FAMATINA": {
      "5365": true
    },
    "CAMPANAS": {
      "5366": true
    },
    "SAÑOGASTA": {
      "5367": true
    },
    "PAGANCILLO": {
      "5369": true
    },
    "PITUIL": {
      "5370": true
    },
    "NONOGASTA": {
      "5372": true
    },
    "LOS SARMIENTOS": {
      "5373": true
    },
    "VICHIGASTA": {
      "5374": true
    },
    "BARRIO DE GALLI": {
      "5375": true
    },
    "CARRIZAL TAMA": {
      "5376": true
    },
    "CHILA": {
      "5378": true
    },
    "VILLA SANAGASTA": {
      "5379": true
    },
    "CHAMICAL": {
      "5380": true
    },
    "BELLA VISTA": {
      "5381": true
    },
    "LOMA BLANCA": {
      "5382": true
    },
    "OLTA": {
      "5383": true
    },
    "PUNTA DE LOS LLANOS": {
      "5384": true
    },
    "TUIZON": {
      "5385": true
    },
    "PATQUIA": {
      "5386": true
    },
    "ATILES": {
      "5388": true
    },
    "MALANZAN": {
      "5389": true
    },
    "CHEPES": {
      "5470": true
    },
    "MASCASIN": {
      "5471": true
    },
    "CILLA NIDIA": {
      "5473": true
    },
    "DESIDERIO TELLO": {
      "5474": true
    },
    "CHELCOS": {
      "5475": true
    },
    "EL CALDEN": {
      "5717": true
    }
  },
  "SAN JUAN": {
    "SAN JUAN": {
      "5400": true,
      "5402": true,
      "5406": true,
      "5422": true,
      "5452": true
    },
    "ZONDA": {
      "5401": true,
      "5451": true
    },
    "CALINGASTA": {
      "5403": true
    },
    "BARREAL": {
      "5405": true
    },
    "MARQUESADO": {
      "5407": true
    },
    "ULLUN": {
      "5409": true
    },
    "VILLA PALERMO": {
      "5410": true
    },
    "SANTA LUCIA": {
      "5411": true
    },
    "MOGNA": {
      "5412": true
    },
    "CHIMBAS": {
      "5413": true
    },
    "ULLUM": {
      "5414": true
    },
    "VILLA DEL SALVADOR": {
      "5415": true
    },
    "SAN ISIDRO": {
      "5416": true
    },
    "LAS CHACRITAS": {
      "5417": true
    },
    "SAN MARTIN": {
      "5418": true
    },
    "ALBARDON": {
      "5419": true
    },
    "RAWSON": {
      "5420": true,
      "5423": true
    },
    "COLONIA RODAS": {
      "5421": true
    },
    "VILLA LERGA": {
      "5424": true
    },
    "VILLA KRAUSE": {
      "5425": true
    },
    "CAMPO AFUERA": {
      "5426": true
    },
    "VILLA ABERASTAIN": {
      "5427": true
    },
    "ABERASTAIN": {
      "5428": true
    },
    "RINCONADA": {
      "5429": true
    },
    "LA CAÑADA": {
      "5430": true
    },
    "CAÑADA HONDA": {
      "5431": true
    },
    "ESTACION LA RINCONADA": {
      "5433": true
    },
    "CAMPO DE BATALLA": {
      "5434": true
    },
    "MEDIA AGUA": {
      "5435": true
    },
    "COLONIA ZAPATA": {
      "5436": true
    },
    "CARPINTERIA": {
      "5437": true
    },
    "ALTO DE SIERRA": {
      "5438": true
    },
    "DOS ACEQUIAS": {
      "5439": true
    },
    "LAS TAPIAS": {
      "5440": true
    },
    "CAUCETE": {
      "5441": true,
      "5442": true
    },
    "DIFUNTA CORREA": {
      "5443": true
    },
    "PIE DE PALO": {
      "5444": true
    },
    "TUPELI": {
      "5445": true
    },
    "MARAYES": {
      "5446": true
    },
    "ASTICA": {
      "5447": true
    },
    "VALLE FERTIL": {
      "5449": true
    },
    "COLONIA FISCAL SARMIENTO": {
      "5450": true
    },
    "PUNTA DEL MONTE": {
      "5454": true
    },
    "EL BOSQUE": {
      "5455": true
    },
    "CHACRITAS": {
      "5456": true
    },
    "LAS FLORES": {
      "5458": true
    },
    "HUACO": {
      "5459": true,
      "5463": true
    },
    "JACHAL": {
      "5460": true
    },
    "EL FICAL": {
      "5461": true,
      "5464": true
    },
    "RODEO": {
      "5465": true
    },
    "LA CHIMBERA": {
      "5466": true
    },
    "IGLESIA": {
      "5467": true
    },
    "PAMPA DEL CHAÑAR": {
      "5468": true
    },
    "PAMPA VIEJA": {
      "5469": true
    }
  },
  "MENDOZA": {
    "MENDOZA": {
      "5500": true,
      "5502": true,
      "5504": true
    },
    "GODOY CRUZ": {
      "5501": true
    },
    "SAN FRANCISCO DEL MONTE": {
      "5503": true
    },
    "CARRODILLA": {
      "5505": true
    },
    "LUJAN DE CUYO": {
      "5507": true
    },
    "PERDRIEL": {
      "5509": true
    },
    "PAREDITAS": {
      "5510": true
    },
    "GENERAL GUTIERREZ": {
      "5511": true
    },
    "SAN CARLOS": {
      "5512": true
    },
    "COQUIMBITO": {
      "5513": true,
      "5522": true
    },
    "TRES ESQUINAS": {
      "5514": true
    },
    "MAIPU": {
      "5515": true
    },
    "LUZURIAGA": {
      "5516": true
    },
    "RUSSELL": {
      "5517": true,
      "5581": true
    },
    "SAN JOSE DE GUAYMALLEN": {
      "5519": true
    },
    "BARRIO QUIMICOS M.D.C.1": {
      "5520": true
    },
    "VILLA NUEVA DE GUAYMALLEN": {
      "5521": true
    },
    "BUENA NUEVA": {
      "5523": true
    },
    "COLONIA CANO": {
      "5524": true
    },
    "RODEO DE LA CRUZ": {
      "5525": true
    },
    "LOS CAMPAMENTOS": {
      "5526": true
    },
    "LOS CORRALITOS": {
      "5527": true
    },
    "CHACRAS DE CORIA": {
      "5528": true
    },
    "RODEO DEL MEDIO": {
      "5529": true
    },
    "SAN JOSE": {
      "5530": true
    },
    "FRAY LUIS BELTRAN": {
      "5531": true
    },
    "MINELLI": {
      "5532": true
    },
    "BERMEJO": {
      "5533": true
    },
    "MAYOR DRUMMOND": {
      "5534": true
    },
    "COSTA DE ARAUJO": {
      "5535": true
    },
    "MUNDO NUEVO": {
      "5536": true
    },
    "SAN MIGUEL": {
      "5537": true
    },
    "PHILIPPS": {
      "5538": true
    },
    "LAS HERAS": {
      "5539": true,
      "5540": true
    },
    "ALGARROBAL": {
      "5541": true
    },
    "EL PLUMERILLO": {
      "5542": true
    },
    "3 DE MAYO": {
      "5543": true,
      "5548": true
    },
    "GOBERNADOR BENEGAS": {
      "5544": true
    },
    "USPALLATA": {
      "5545": true
    },
    "UGARTECHE": {
      "5546": true
    },
    "VILLA HIPODROMO": {
      "5547": true
    },
    "CACHEUTA": {
      "5549": true
    },
    "COMPUERTAS": {
      "5550": true
    },
    "POLVAREDA": {
      "5551": true
    },
    "POTRERILLOS": {
      "5552": true
    },
    "PUNTA DE VACAS": {
      "5553": true
    },
    "BARRIO RIVADAVIA": {
      "5554": true
    },
    "PUENTE DEL INCA": {
      "5555": true
    },
    "CARRIZAL DE ABAJO": {
      "5556": true
    },
    "LAS CUEVAS": {
      "5557": true
    },
    "LA LIBERTAD": {
      "5558": true
    },
    "LOS ARBOLES": {
      "5559": true,
      "5575": true
    },
    "TUNUYAN": {
      "5560": true
    },
    "TUPUNGATO": {
      "5561": true
    },
    "VILLA BASTIAS": {
      "5562": true
    },
    "LOS ARBOLES DE VILLEGAS": {
      "5563": true
    },
    "BARRIO LENCINA": {
      "5564": true
    },
    "COLONIA LAS ROSAS": {
      "5565": true,
      "5662": true
    },
    "LA COLONIA": {
      "5566": true,
      "5572": true
    },
    "LA CONSULTA": {
      "5567": true
    },
    "EL MIRADOR": {
      "5568": true
    },
    "EUGENIO BUSTOS": {
      "5569": true
    },
    "SAN MARTIN": {
      "5570": true
    },
    "MONTE CASEROS": {
      "5571": true,
      "5671": true
    },
    "CIUDAD DE JUNIN": {
      "5573": true
    },
    "LA CENTRAL RIVADAVIA": {
      "5574": true
    },
    "SANTA MARIA DE ORO": {
      "5576": true
    },
    "RIVADAVIA": {
      "5577": true
    },
    "BARRIO SAN EDUARDO": {
      "5578": true
    },
    "LA CENTRAL": {
      "5579": true
    },
    "EL CENTRAL": {
      "5580": true
    },
    "INGENIERO GIAGNONI": {
      "5582": true
    },
    "EL DIVISADERO": {
      "5583": true
    },
    "PALMIRA": {
      "5584": true
    },
    "LOS BARRIALES": {
      "5585": true,
      "5668": true
    },
    "CRUZ DE PIEDRA": {
      "5586": true
    },
    "SAN ROQUE": {
      "5587": true,
      "5650": true
    },
    "VILLA SECA": {
      "5588": true
    },
    "CHAPANAY": {
      "5589": true
    },
    "LA PAZ": {
      "5590": true
    },
    "ALPATACAL": {
      "5591": true
    },
    "LA DORMIDA": {
      "5592": true
    },
    "LUNLUNTA": {
      "5593": true
    },
    "LAS CATITAS": {
      "5594": true
    },
    "ÑACUÑAN": {
      "5595": true
    },
    "SANTA ROSA": {
      "5596": true
    },
    "12 DE OCTUBRE": {
      "5597": true
    },
    "DESAGUADERO": {
      "5598": true
    },
    "SAN RAFAEL": {
      "5600": true,
      "5602": true,
      "8600": true
    },
    "RESOLANA": {
      "5601": true
    },
    "PEDRO VARGAS": {
      "5603": true,
      "5617": true
    },
    "SANTA TERESA": {
      "5605": true,
      "5640": true
    },
    "GENERAL ORTEGA": {
      "5606": true
    },
    "CUADRO NACIONAL": {
      "5607": true
    },
    "LLAVE NUEVA": {
      "5608": true
    },
    "MONTE COMAN": {
      "5609": true
    },
    "EL SOSNEADO": {
      "5611": true
    },
    "LAS LEÑAS": {
      "5612": true
    },
    "MALARGUE": {
      "5613": true
    },
    "LOS CAVAOS": {
      "5614": true
    },
    "25 DE MAYO": {
      "5615": true
    },
    "PUEBLO ECHEVARRIETA": {
      "5618": true
    },
    "RAMA CAIDA": {
      "5619": true
    },
    "GENERAL ALVEAR": {
      "5620": true
    },
    "VILLA ATUEL": {
      "5622": true
    },
    "JAIME PRATS": {
      "5623": true
    },
    "REAL DEL PADRE": {
      "5624": true
    },
    "VILLA VEINTICINCO DE MAYO": {
      "5625": true
    },
    "CORONEL DORREGO": {
      "5626": true
    },
    "PUNTA DEL AGUA": {
      "5627": true
    },
    "RODOLFO ISELIN": {
      "5628": true
    },
    "EL TROPEZON": {
      "5629": true
    },
    "INGENIERO BALLOFFET": {
      "5630": true
    },
    "GOUDGE": {
      "5631": true
    },
    "COLONIA ALVEAR": {
      "5632": true
    },
    "MEDRANO": {
      "5633": true
    },
    "BOWEN": {
      "5634": true
    },
    "LAS MALVINAS": {
      "5635": true
    },
    "CANALEJAS": {
      "5636": true
    },
    "CORRAL DE LORCA": {
      "5637": true
    },
    "JESUS NAZARENO": {
      "5638": true
    },
    "PRIMAVERA": {
      "5641": true
    },
    "EL CEIBO": {
      "5644": true
    },
    "REDUCCION": {
      "5645": true
    },
    "COLONIA SEGOVIA": {
      "5646": true
    },
    "LA ESCANDINAVA": {
      "5647": true
    },
    "LOS COMPARTOS": {
      "5648": true
    },
    "COLONIA SANTA TERESA": {
      "5649": true
    },
    "PEDREGAL": {
      "5651": true
    },
    "CHILECITO": {
      "5652": true
    },
    "COLONIA LAMBARE": {
      "5653": true
    },
    "EL ALTO SALVADOR": {
      "5654": true
    },
    "SANTA BLANCA": {
      "5655": true
    },
    "LOS ALAMOS": {
      "5656": true
    },
    "ESPINO": {
      "5657": true
    },
    "CARTELLONE": {
      "5658": true
    },
    "LAS COLONIAS": {
      "5659": true
    },
    "CORDON DE PLATA": {
      "5661": true
    },
    "LOS SAUCES": {
      "5663": true
    },
    "LAVALLE VILLA TULUMAYA": {
      "5664": true
    },
    "VISTA FLORES": {
      "5665": true
    },
    "EL BORBOLLON": {
      "5666": true
    },
    "SAN JOSE DE TUPUNGATO": {
      "5667": true
    },
    "RODRIGUEZ PEÑA": {
      "5669": true
    },
    "BUEN ORDEN": {
      "5670": true
    },
    "ISLA GRANDE": {
      "5672": true
    },
    "QUINTO CUARTEL": {
      "5674": true
    },
    "EL MEDANITO": {
      "5675": true
    },
    "MEDANO DE ORO": {
      "5676": true
    },
    "PARAJE BEBIDA": {
      "5677": true
    },
    "COLONIA RICHET": {
      "5678": true
    },
    "LA LEGUA": {
      "5679": true
    },
    "LAS LAGUNAS": {
      "5680": true
    },
    "ASTICA": {
      "5681": true
    },
    "SAN JUAN BAUTISTA USNO": {
      "5682": true
    },
    "IGLESIA": {
      "5684": true
    },
    "LA ISLA": {
      "5685": true
    },
    "TUDCUM": {
      "5686": true
    }
  },
  "LA PAMPA": {
    "CARMENSA": {
      "5621": true
    },
    "REALICO": {
      "6200": true
    },
    "CHANILAO": {
      "6201": true
    },
    "EMBAJADOR MARTINI": {
      "6203": true
    },
    "INGENIERO LUIGGI": {
      "6205": true
    },
    "ALTA ITALIA": {
      "6207": true
    },
    "PUEBLO ALASSA": {
      "6208": true
    },
    "MAISONNAVE": {
      "6211": true
    },
    "QUETREQUEN": {
      "6212": true
    },
    "PARERA": {
      "6213": true
    },
    "CHAMAICO": {
      "6214": true
    },
    "FALUCHO": {
      "6215": true
    },
    "NUEVA GALIA": {
      "6217": true
    },
    "BAGUAL": {
      "6218": true
    },
    "BERNARDO LARROUDE": {
      "6220": true
    },
    "INTENDENTE ALVEAR": {
      "6221": true
    },
    "SARAH": {
      "6228": true
    },
    "SANTA ROSA": {
      "6300": true,
      "6302": true,
      "6304": true
    },
    "ATALIVA ROCA": {
      "6301": true
    },
    "TOAY": {
      "6303": true
    },
    "DOBLAS": {
      "6305": true
    },
    "MACACHIN": {
      "6307": true
    },
    "ALPACHIRI": {
      "6309": true
    },
    "GUATRACHE": {
      "6311": true
    },
    "RICARDO LAVALLE": {
      "6312": true
    },
    "WINIFREDA": {
      "6313": true
    },
    "COLONIA SAN JOSE": {
      "6315": true
    },
    "LUAN TORO": {
      "6317": true
    },
    "VICTORICA": {
      "6319": true
    },
    "TELEN": {
      "6321": true
    },
    "SANTA ISABEL": {
      "6323": true
    },
    "NAICO": {
      "6325": true
    },
    "ANGUIL": {
      "6326": true
    },
    "CATRILO": {
      "6330": true
    },
    "RELMO": {
      "6331": true
    },
    "QUEMU QUEMU": {
      "6333": true
    },
    "LA BILBAINA": {
      "6345": true
    },
    "LONQUIMAY": {
      "6352": true
    },
    "URIBURU": {
      "6354": true
    },
    "GENERAL PICO": {
      "6360": true,
      "6388": true
    },
    "TREBOLARES": {
      "6361": true
    },
    "SPELUZZI": {
      "6365": true
    },
    "METILEO": {
      "6367": true
    },
    "TRENEL": {
      "6369": true
    },
    "EDUARDO CASTEX": {
      "6380": true
    },
    "CONHELO": {
      "6381": true
    },
    "MONTE NIEVAS": {
      "6383": true
    },
    "ARATA": {
      "6385": true
    },
    "LA MARUJA": {
      "6386": true
    },
    "CALEUFU": {
      "6387": true
    },
    "MIRA PAMPA": {
      "6403": true
    },
    "LA ROSA": {
      "8133": true
    },
    "RIO COLORADO": {
      "8138": true
    },
    "GENERAL ACHA": {
      "8200": true
    },
    "COLONIA VEINTICINCO DE MAYO": {
      "8201": true
    },
    "QUEHUE": {
      "8203": true
    },
    "BERNASCONI": {
      "8204": true
    },
    "GENERAL SAN MARTIN": {
      "8206": true
    },
    "JACINTO ARAUZ": {
      "8208": true
    },
    "PERU": {
      "8212": true
    },
    "UNANUE": {
      "8214": true
    },
    "CATRIEL": {
      "8307": true
    },
    "GENERAL FERNANDEZ ORO": {
      "8325": true
    },
    "PADRE ALEJANDRO STEFANELLI": {
      "8335": true
    }
  },
  "CHUBUT": {
    "CUSHAMEN": {
      "8211": true,
      "9211": true
    },
    "MAMUEL CHOIQUE": {
      "8415": true
    },
    "EL BOLSON": {
      "8430": true
    },
    "LAGO PUELO": {
      "8431": true
    },
    "COMODORO RIVADAVIA": {
      "9000": true,
      "9002": true,
      "9004": true,
      "9006": true,
      "9008": true,
      "9010": true,
      "9018": true
    },
    "RADA TILLY": {
      "9001": true
    },
    "DON BOSCO": {
      "9003": true
    },
    "GENERAL MOSCONI": {
      "9005": true
    },
    "UZCUDUM": {
      "9007": true
    },
    "DIADEMA ARGENTINA": {
      "9009": true
    },
    "SARMIENTO": {
      "9020": true
    },
    "COLHUE HUAPI": {
      "9021": true
    },
    "BUEN PASTO": {
      "9023": true
    },
    "RIO MAYO": {
      "9030": true
    },
    "FACUNDO": {
      "9031": true
    },
    "ALTO RIO SENGUER": {
      "9033": true
    },
    "DR.RICARDO ROJAS": {
      "9035": true
    },
    "ALDEA BELEIRO": {
      "9037": true
    },
    "LAGO BLANCO": {
      "9039": true
    },
    "TRELEW": {
      "9100": true,
      "9102": true
    },
    "PUENTE HENDRE": {
      "9101": true
    },
    "RAWSON": {
      "9103": true
    },
    "GAIMAN": {
      "9105": true
    },
    "DOLAVON": {
      "9107": true
    },
    "CAMARONES": {
      "9111": true
    },
    "FLORENTINO AMEGHINO": {
      "9113": true
    },
    "PUERTO MADRYN": {
      "9120": true
    },
    "PUERTO PIRAMIDES": {
      "9121": true
    },
    "ARROYO VERDE": {
      "9123": true
    },
    "ESQUEL": {
      "9200": true,
      "9202": true
    },
    "PARQUE NACIONAL LOS ALERCES": {
      "9201": true
    },
    "TREVELIN": {
      "9203": true
    },
    "PASO DE INDIOS": {
      "9207": true
    },
    "EL MAITEN": {
      "9210": true
    },
    "LELEQUE": {
      "9213": true
    },
    "CHOLILA": {
      "9217": true
    },
    "JOSE DE SAN MARTIN": {
      "9220": true
    },
    "VALLE HONDO": {
      "9221": true
    },
    "GOBERNADOR COSTA": {
      "9223": true
    },
    "RIO PICO": {
      "9225": true
    },
    "CHILQUENILAHUE": {
      "9227": true
    },
    "CORCOVADO": {
      "9204": true
    }
  },
  "NEUQUEN": {
    "NEUQUEN": {
      "8300": true,
      "8302": true,
      "8304": true,
      "8321": true,
      "8357": true,
      "8375": true
    },
    "COLONIA VALENTINA": {
      "8301": true
    },
    "BARDA DEL MEDIO": {
      "8305": true
    },
    "SAN PATRICIO DEL CHAÑAR": {
      "8306": true
    },
    "CENTENARIO": {
      "8309": true
    },
    "VILLA EL CHOCON": {
      "8311": true
    },
    "PASO AGUERRE": {
      "8313": true
    },
    "PIEDRA DEL AGUILA": {
      "8315": true
    },
    "PLOTTIER": {
      "8316": true
    },
    "PLAZA HUINCUL": {
      "8318": true
    },
    "RINCON DE LOS SAUCES": {
      "8319": true
    },
    "SENILLOSA": {
      "8320": true
    },
    "CUTRAL CO": {
      "8322": true
    },
    "CIPOLETTI": {
      "8327": true
    },
    "ZAPALA": {
      "8340": true,
      "8356": true,
      "8365": true
    },
    "LAS COLORADAS": {
      "8341": true
    },
    "MOQUEHUA": {
      "8344": true
    },
    "ALUMINE": {
      "8345": true
    },
    "CAVIAHUE": {
      "8346": true
    },
    "LAS LAJAS": {
      "8347": true
    },
    "COPAHUE": {
      "8348": true
    },
    "EL HUECU": {
      "8349": true
    },
    "MARIANO MORENO": {
      "8351": true
    },
    "EL CHOLAR": {
      "8353": true,
      "8362": true
    },
    "ANDACOLLO": {
      "8354": true
    },
    "SAN MARTIN DE LOS ANDES": {
      "8370": true
    },
    "JUNIN DE LOS ANDES": {
      "8371": true
    },
    "PAMPA DEL MALLEO": {
      "8373": true
    },
    "GENTE GRANDE": {
      "8379": true
    },
    "CERRO CATEDRAL": {
      "8401": true
    },
    "TRAFUL": {
      "8403": true
    },
    "DINA HUAPI": {
      "8404": true,
      "8406": true
    },
    "VILLA LOS COLIHUES": {
      "8405": true
    },
    "VILLA LA ANGOSTURA": {
      "8407": true
    }
  },
  "RIO NEGRO": {
    "CINCO SALTOS": {
      "8303": true
    },
    "VILLA MANZANO": {
      "8308": true
    },
    "GENERAL FERNANDEZ ORO": {
      "8324": true
    },
    "MAINQUE": {
      "8326": true
    },
    "ALLEN": {
      "8328": true
    },
    "GENERAL ROCA": {
      "8332": true
    },
    "EL CUY": {
      "8333": true
    },
    "INGENIERO HUERGO": {
      "8334": true
    },
    "VILLA REGINA": {
      "8336": true
    },
    "CHICHINALES": {
      "8337": true
    },
    "CHOELE CHOEL": {
      "8360": true
    },
    "LUIS BELTRAN": {
      "8361": true
    },
    "LAMARQUE": {
      "8363": true
    },
    "DARWIN": {
      "8364": true,
      "8369": true
    },
    "CHELFORO": {
      "8366": true
    },
    "BARILOCHE": {
      "8400": true,
      "8408": true,
      "8480": true
    },
    "DINA HUAPI": {
      "8402": true
    },
    "LLAO LLAO": {
      "8409": true
    },
    "LAGUNA FRIA": {
      "8411": true
    },
    "PILCANIYEU": {
      "8412": true
    },
    "CLEMENTE ONELLI": {
      "8416": true
    },
    "CAÑADON CHILENO": {
      "8417": true
    },
    "INGENIERO JACOBACCI": {
      "8418": true
    },
    "MAQUINCHAO": {
      "8422": true
    },
    "LOS MENUCOS": {
      "8424": true
    },
    "VIEDMA": {
      "8500": true,
      "8507": true
    },
    "BALNEARIO EL CONDOR": {
      "8501": true
    },
    "GENERAL CONESA": {
      "8503": true
    },
    "GENERAL LORENZO VINTTER": {
      "8514": true
    },
    "SAN ANTONIO OESTE": {
      "8520": true
    },
    "SAN ANTONIO ESTE": {
      "8521": true
    },
    "SIERRA GRANDE": {
      "8532": true
    },
    "AGUADA CECILIO": {
      "8534": true
    },
    "VALCHETA": {
      "8536": true
    },
    "CIPOLLETTI": {
      "8323": true
    }
  },
  "SANTA CRUZ": {
    "CALETA OLIVIA": {
      "9011": true
    },
    "CAÑADON SECO": {
      "9013": true
    },
    "PICO TRUNCADO": {
      "9015": true
    },
    "LAS HERAS": {
      "9017": true
    },
    "KOLUEL KAIKE": {
      "9019": true
    },
    "PERITO MORENO": {
      "9040": true
    },
    "LOS ANTIGUOS": {
      "9041": true
    },
    "PUERTO DESEADO": {
      "9050": true
    },
    "EL HUECO": {
      "9051": true
    },
    "JARAMILLO": {
      "9053": true
    },
    "PUERTO SANTA CRUZ": {
      "9300": true
    },
    "TRES LAGOS": {
      "9301": true
    },
    "COMANDANTE LUIS PIEDRABUENA": {
      "9303": true
    },
    "CAÑADA DE LAS VACAS": {
      "9305": true
    },
    "PUERTO SAN JULIAN": {
      "9310": true
    },
    "GOBERNADOR GREGORES": {
      "9311": true
    },
    "CARA MALA": {
      "9313": true
    },
    "BAJO CARACOLES": {
      "9315": true
    },
    "RIO GALLEGOS": {
      "9400": true,
      "9402": true,
      "9403": true
    },
    "BELLA VISTA": {
      "9401": true
    },
    "EL CALAFATE": {
      "9405": true
    },
    "RIO TURBIO": {
      "9407": true
    },
    "28 DE NOVIEMBRE": {
      "9408": true
    },
    "Rospentek": {
      "9398": true
    }
  },
  "TIERRA DEL FUEGO": {
    "PUERTO ARGENTINO": {
      "9409": true
    },
    "RIO GRANDE": {
      "9410": true,
      "9420": true
    },
    "ANTARTIDA E ISLAS DEL SUR": {
      "9411": true
    },
    "BARRIO SAN VICENTE DE PAUL": {
      "9412": true
    },
    "USHUAIA": {
      "9413": true
    },
    "FRIGORIFICO CAP": {
      "9421": true
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    // Cidade deve ficar livre para o cliente digitar.
    // Não manipulamos cidade nem CEP aqui.
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    /* zip_code field is now a free text input — no dropdown manipulation needed */
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      // Não sobrescrever a cidade: queremos campo de texto livre.
    } else if (item.type == "zip_code") {
      /* zip_code field left as default text input — validated inline via metafield */
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}